//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const KI_API_BASE_URL = new InjectionToken<string>('KI_API_BASE_URL');

export interface ITestClient {
    /**
     * Primer getAll akcije koja dovlači sve podatke Test entiteta iz baze.
     * @param message (optional) 
     */
    getAll(message?: string | null | undefined): Observable<void>;
    /**
     * Primer getById akcije koja dovlači željeni entitet iz baze.
     * @param id (optional) 
     */
    getById(id?: number | undefined): Observable<void>;
    /**
     * Primer getByMessage akcije koja dovlači entitete sa odgovarajućom porukom iz baze.
     * @param message (optional) 
     */
    getByMessage(message?: string | null | undefined): Observable<void>;
    /**
     * Primer insert komande koja unosi nov Test rekord u bazu.
     */
    insert(command: TestCreateOrUpdateCommand): Observable<void>;
    /**
     * Primer update komande koja ažurira željeni entitet u bazi.
     */
    update(command: TestCreateOrUpdateCommand): Observable<void>;
    /**
     * Primer delete akcije koja briše Test entitet iz baze na osnovu prosleđene komande.
     */
    delete(command: DeleteTestCommand): Observable<void>;
    /**
     * Primer exporta u excel
     * @param query (optional) 
     */
    export(query?: ExcelExportTestQuery | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class TestClient implements ITestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(KI_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9100";
    }

    /**
     * Primer getAll akcije koja dovlači sve podatke Test entiteta iz baze.
     * @param message (optional) 
     */
    getAll(message?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/getAll?";
        if (message !== undefined && message !== null)
            url_ += "Message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Primer getById akcije koja dovlači željeni entitet iz baze.
     * @param id (optional) 
     */
    getById(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/getById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Primer getByMessage akcije koja dovlači entitete sa odgovarajućom porukom iz baze.
     * @param message (optional) 
     */
    getByMessage(message?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/getByMessage?";
        if (message !== undefined && message !== null)
            url_ += "Message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetByMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Primer insert komande koja unosi nov Test rekord u bazu.
     */
    insert(command: TestCreateOrUpdateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Primer update komande koja ažurira željeni entitet u bazi.
     */
    update(command: TestCreateOrUpdateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Primer delete akcije koja briše Test entitet iz baze na osnovu prosleđene komande.
     */
    delete(command: DeleteTestCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Primer exporta u excel
     * @param query (optional) 
     */
    export(query?: ExcelExportTestQuery | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/export?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ITeritorijalneNadleznostiClient {
    /**
     * Kreiranje teritorijalne nadleznosti - SacuvajTeritorijalnuNadleznostCommandHandler
     */
    kreiranjeTerNadleznosti(command: SacuvajTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString>;
    /**
     * Izmena teritorijalne nadleznosti - SacuvajTeritorijalnuNadleznostCommandHandler
     */
    izmenaTerNadleznosti(command: SacuvajTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString>;
    /**
     * Kreiranje nove verzije teritorijalne nadleznosti - SacuvajTeritorijalnuNadleznostCommandHandler
     */
    kreiranjeNoveVerzijeTerNadleznosti(command: SacuvajTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString>;
    /**
     * Objava teritorijalne nadleznosti
     */
    objaviTerNadleznost(command: ObjaviTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString>;
    /**
     * Objava teritorijalne nadleznosti
     */
    izmeniIObjaviTerNadleznost(command: ObjaviTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString>;
    /**
     * Objava teritorijalne nadleznosti
     */
    kreirajNovuVerzijuIObjaviTerNadleznost(command: ObjaviTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString>;
    /**
     * Pretraga sifarnika stavki ter. nadleznosti
     * @param naziv (optional) 
     * @param sifraTipaTeritorijalneNadleznosti (optional) 
     * @param sifraOrgana (optional) 
     */
    pretraziStavke(naziv?: string | null | undefined, sifraTipaTeritorijalneNadleznosti?: string | null | undefined, sifraOrgana?: string | null | undefined): Observable<PretragaStavkiTerNadleznostiResponse>;
    /**
     * Uzimanje podataka teritorijalne nadleznosti
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajPodatkeTerNadleznosti(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<TeritorijalnaNadleznostPodaciResponse>;
    /**
     * Pretraga teritorijalnih nadleznosti po parametrima pretrage
     * @param naziv (optional) 
     * @param sifraTipaTeritorijalneNadleznosti (optional) 
     * @param sifraTeritorijalneJedinice (optional) 
     * @param sifraNadleznogOrganizacionogEntiteta (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param jeDetaljnaPretraga (optional) 
     * @param sifraOrgana (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    dajTeritorijalneNadleznostiPoKriterijumuPretrage(naziv?: string | null | undefined, sifraTipaTeritorijalneNadleznosti?: string | null | undefined, sifraTeritorijalneJedinice?: string | null | undefined, sifraNadleznogOrganizacionogEntiteta?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, jeDetaljnaPretraga?: boolean | undefined, sifraOrgana?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse>;
    /**
     * Vracanje verzija teritorijalne nadleznosti po sifri
     * @param sifra (optional) 
     */
    getVerzijeTerNadleznoti(sifra?: string | null | undefined): Observable<DajVerzijeTeritorijalneNadleznostiResponse>;
    /**
     * Izvoz rezultata pretrage teritorijalnih nadleznosti u excel
     * @param lang (optional) 
     * @param naziv (optional) 
     * @param sifraTipaTeritorijalneNadleznosti (optional) 
     * @param sifraTeritorijalneJedinice (optional) 
     * @param sifraNadleznogOrganizacionogEntiteta (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param jeDetaljnaPretraga (optional) 
     * @param sifraOrgana (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozTeritorijalnihNadleznostiUExcel(lang?: string | null | undefined, naziv?: string | null | undefined, sifraTipaTeritorijalneNadleznosti?: string | null | undefined, sifraTeritorijalneJedinice?: string | null | undefined, sifraNadleznogOrganizacionogEntiteta?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, jeDetaljnaPretraga?: boolean | undefined, sifraOrgana?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string>;
    /**
     * Brisanje teritorijalne nadleznosti
     */
    obrisiTeritorijalnuNadleznost(command: ObrisiTeritorijalnuNadleznostCommand): Observable<GenericActionResponse>;
    /**
     * Deaktiviranje teritorijalne nadleznosti
     */
    deaktivirajTeritorijalnuNadleznost(command: DeaktivirajTeritorijalnuNadleznostCommand): Observable<GenericActionResponse>;
    /**
     * Vracanje teritorijalne nadleznosti iz statusa Ceka upis u katalog u Podaci u pripremi
     */
    povratakTeritorijalneNadleznostiNaStatusUPripremi(command: PovratakTeritorijalneNadleznostiNaStatusUPripremiCommand): Observable<GenericActionResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TeritorijalneNadleznostiClient implements ITeritorijalneNadleznostiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(KI_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9100";
    }

    /**
     * Kreiranje teritorijalne nadleznosti - SacuvajTeritorijalnuNadleznostCommandHandler
     */
    kreiranjeTerNadleznosti(command: SacuvajTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/kreiranjeTerNadleznosti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreiranjeTerNadleznosti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreiranjeTerNadleznosti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfString>;
        }));
    }

    protected processKreiranjeTerNadleznosti(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfString.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfString>(null as any);
    }

    /**
     * Izmena teritorijalne nadleznosti - SacuvajTeritorijalnuNadleznostCommandHandler
     */
    izmenaTerNadleznosti(command: SacuvajTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/izmenaTerNadleznosti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzmenaTerNadleznosti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmenaTerNadleznosti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfString>;
        }));
    }

    protected processIzmenaTerNadleznosti(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfString.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfString>(null as any);
    }

    /**
     * Kreiranje nove verzije teritorijalne nadleznosti - SacuvajTeritorijalnuNadleznostCommandHandler
     */
    kreiranjeNoveVerzijeTerNadleznosti(command: SacuvajTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/kreiranjeNoveVerzijeTerNadleznosti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreiranjeNoveVerzijeTerNadleznosti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreiranjeNoveVerzijeTerNadleznosti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfString>;
        }));
    }

    protected processKreiranjeNoveVerzijeTerNadleznosti(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfString.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfString>(null as any);
    }

    /**
     * Objava teritorijalne nadleznosti
     */
    objaviTerNadleznost(command: ObjaviTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/objaviTerNadleznost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObjaviTerNadleznost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviTerNadleznost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfString>;
        }));
    }

    protected processObjaviTerNadleznost(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfString.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfString>(null as any);
    }

    /**
     * Objava teritorijalne nadleznosti
     */
    izmeniIObjaviTerNadleznost(command: ObjaviTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/izmeniIObjaviTerNadleznost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzmeniIObjaviTerNadleznost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmeniIObjaviTerNadleznost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfString>;
        }));
    }

    protected processIzmeniIObjaviTerNadleznost(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfString.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfString>(null as any);
    }

    /**
     * Objava teritorijalne nadleznosti
     */
    kreirajNovuVerzijuIObjaviTerNadleznost(command: ObjaviTeritorijalnuNadleznostCommand): Observable<GenericActionResponseWithItemsKIOfString> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/kreirajNovuVerzijuIObjaviTerNadleznost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreirajNovuVerzijuIObjaviTerNadleznost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajNovuVerzijuIObjaviTerNadleznost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfString>;
        }));
    }

    protected processKreirajNovuVerzijuIObjaviTerNadleznost(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfString.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfString>(null as any);
    }

    /**
     * Pretraga sifarnika stavki ter. nadleznosti
     * @param naziv (optional) 
     * @param sifraTipaTeritorijalneNadleznosti (optional) 
     * @param sifraOrgana (optional) 
     */
    pretraziStavke(naziv?: string | null | undefined, sifraTipaTeritorijalneNadleznosti?: string | null | undefined, sifraOrgana?: string | null | undefined): Observable<PretragaStavkiTerNadleznostiResponse> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/stavke/pretazi?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (sifraTipaTeritorijalneNadleznosti !== undefined && sifraTipaTeritorijalneNadleznosti !== null)
            url_ += "SifraTipaTeritorijalneNadleznosti=" + encodeURIComponent("" + sifraTipaTeritorijalneNadleznosti) + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPretraziStavke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretraziStavke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PretragaStavkiTerNadleznostiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PretragaStavkiTerNadleznostiResponse>;
        }));
    }

    protected processPretraziStavke(response: HttpResponseBase): Observable<PretragaStavkiTerNadleznostiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PretragaStavkiTerNadleznostiResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PretragaStavkiTerNadleznostiResponse>(null as any);
    }

    /**
     * Uzimanje podataka teritorijalne nadleznosti
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajPodatkeTerNadleznosti(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<TeritorijalnaNadleznostPodaciResponse> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/podaci?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajPodatkeTerNadleznosti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPodatkeTerNadleznosti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeritorijalnaNadleznostPodaciResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeritorijalnaNadleznostPodaciResponse>;
        }));
    }

    protected processDajPodatkeTerNadleznosti(response: HttpResponseBase): Observable<TeritorijalnaNadleznostPodaciResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TeritorijalnaNadleznostPodaciResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TeritorijalnaNadleznostPodaciResponse>(null as any);
    }

    /**
     * Pretraga teritorijalnih nadleznosti po parametrima pretrage
     * @param naziv (optional) 
     * @param sifraTipaTeritorijalneNadleznosti (optional) 
     * @param sifraTeritorijalneJedinice (optional) 
     * @param sifraNadleznogOrganizacionogEntiteta (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param jeDetaljnaPretraga (optional) 
     * @param sifraOrgana (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    dajTeritorijalneNadleznostiPoKriterijumuPretrage(naziv?: string | null | undefined, sifraTipaTeritorijalneNadleznosti?: string | null | undefined, sifraTeritorijalneJedinice?: string | null | undefined, sifraNadleznogOrganizacionogEntiteta?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, jeDetaljnaPretraga?: boolean | undefined, sifraOrgana?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/dajTeritorijalneNadleznostiPoKriterijumu?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (sifraTipaTeritorijalneNadleznosti !== undefined && sifraTipaTeritorijalneNadleznosti !== null)
            url_ += "SifraTipaTeritorijalneNadleznosti=" + encodeURIComponent("" + sifraTipaTeritorijalneNadleznosti) + "&";
        if (sifraTeritorijalneJedinice !== undefined && sifraTeritorijalneJedinice !== null)
            url_ += "SifraTeritorijalneJedinice=" + encodeURIComponent("" + sifraTeritorijalneJedinice) + "&";
        if (sifraNadleznogOrganizacionogEntiteta !== undefined && sifraNadleznogOrganizacionogEntiteta !== null)
            url_ += "SifraNadleznogOrganizacionogEntiteta=" + encodeURIComponent("" + sifraNadleznogOrganizacionogEntiteta) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (jeDetaljnaPretraga === null)
            throw new Error("The parameter 'jeDetaljnaPretraga' cannot be null.");
        else if (jeDetaljnaPretraga !== undefined)
            url_ += "JeDetaljnaPretraga=" + encodeURIComponent("" + jeDetaljnaPretraga) + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajTeritorijalneNadleznostiPoKriterijumuPretrage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajTeritorijalneNadleznostiPoKriterijumuPretrage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse>;
        }));
    }

    protected processDajTeritorijalneNadleznostiPoKriterijumuPretrage(response: HttpResponseBase): Observable<PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse>(null as any);
    }

    /**
     * Vracanje verzija teritorijalne nadleznosti po sifri
     * @param sifra (optional) 
     */
    getVerzijeTerNadleznoti(sifra?: string | null | undefined): Observable<DajVerzijeTeritorijalneNadleznostiResponse> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/verzije?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVerzijeTerNadleznoti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVerzijeTerNadleznoti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajVerzijeTeritorijalneNadleznostiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajVerzijeTeritorijalneNadleznostiResponse>;
        }));
    }

    protected processGetVerzijeTerNadleznoti(response: HttpResponseBase): Observable<DajVerzijeTeritorijalneNadleznostiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajVerzijeTeritorijalneNadleznostiResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajVerzijeTeritorijalneNadleznostiResponse>(null as any);
    }

    /**
     * Izvoz rezultata pretrage teritorijalnih nadleznosti u excel
     * @param lang (optional) 
     * @param naziv (optional) 
     * @param sifraTipaTeritorijalneNadleznosti (optional) 
     * @param sifraTeritorijalneJedinice (optional) 
     * @param sifraNadleznogOrganizacionogEntiteta (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param jeDetaljnaPretraga (optional) 
     * @param sifraOrgana (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozTeritorijalnihNadleznostiUExcel(lang?: string | null | undefined, naziv?: string | null | undefined, sifraTipaTeritorijalneNadleznosti?: string | null | undefined, sifraTeritorijalneJedinice?: string | null | undefined, sifraNadleznogOrganizacionogEntiteta?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, jeDetaljnaPretraga?: boolean | undefined, sifraOrgana?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/izvozTeritorijalnihNadleznostiUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (sifraTipaTeritorijalneNadleznosti !== undefined && sifraTipaTeritorijalneNadleznosti !== null)
            url_ += "SifraTipaTeritorijalneNadleznosti=" + encodeURIComponent("" + sifraTipaTeritorijalneNadleznosti) + "&";
        if (sifraTeritorijalneJedinice !== undefined && sifraTeritorijalneJedinice !== null)
            url_ += "SifraTeritorijalneJedinice=" + encodeURIComponent("" + sifraTeritorijalneJedinice) + "&";
        if (sifraNadleznogOrganizacionogEntiteta !== undefined && sifraNadleznogOrganizacionogEntiteta !== null)
            url_ += "SifraNadleznogOrganizacionogEntiteta=" + encodeURIComponent("" + sifraNadleznogOrganizacionogEntiteta) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (jeDetaljnaPretraga === null)
            throw new Error("The parameter 'jeDetaljnaPretraga' cannot be null.");
        else if (jeDetaljnaPretraga !== undefined)
            url_ += "JeDetaljnaPretraga=" + encodeURIComponent("" + jeDetaljnaPretraga) + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzvozTeritorijalnihNadleznostiUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozTeritorijalnihNadleznostiUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozTeritorijalnihNadleznostiUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Brisanje teritorijalne nadleznosti
     */
    obrisiTeritorijalnuNadleznost(command: ObrisiTeritorijalnuNadleznostCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/obrisiTeritorijalnuNadleznost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObrisiTeritorijalnuNadleznost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiTeritorijalnuNadleznost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processObrisiTeritorijalnuNadleznost(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Deaktiviranje teritorijalne nadleznosti
     */
    deaktivirajTeritorijalnuNadleznost(command: DeaktivirajTeritorijalnuNadleznostCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/deaktivirajTeritorijalnuNadleznost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeaktivirajTeritorijalnuNadleznost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajTeritorijalnuNadleznost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processDeaktivirajTeritorijalnuNadleznost(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Vracanje teritorijalne nadleznosti iz statusa Ceka upis u katalog u Podaci u pripremi
     */
    povratakTeritorijalneNadleznostiNaStatusUPripremi(command: PovratakTeritorijalneNadleznostiNaStatusUPripremiCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/TeritorijalneNadleznosti/povratakTeritorijalneNadleznostiNaStatusUPripremi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPovratakTeritorijalneNadleznostiNaStatusUPripremi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPovratakTeritorijalneNadleznostiNaStatusUPripremi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processPovratakTeritorijalneNadleznostiNaStatusUPripremi(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }
}

export interface ISifarniciClient {
    /**
     * Dohvatanje svih internih sifarnika iz baze IOP
     * @param query (optional) 
     */
    dajSveInterneSifarnike(query?: DajSveInterneSifarnikeQuery | null | undefined): Observable<DajSveInterneSifarnikeResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SifarniciClient implements ISifarniciClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(KI_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9100";
    }

    /**
     * Dohvatanje svih internih sifarnika iz baze IOP
     * @param query (optional) 
     */
    dajSveInterneSifarnike(query?: DajSveInterneSifarnikeQuery | null | undefined): Observable<DajSveInterneSifarnikeResponse> {
        let url_ = this.baseUrl + "/api/Sifarnici/dajSveInterneSifarnike?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveInterneSifarnike(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveInterneSifarnike(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveInterneSifarnikeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveInterneSifarnikeResponse>;
        }));
    }

    protected processDajSveInterneSifarnike(response: HttpResponseBase): Observable<DajSveInterneSifarnikeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveInterneSifarnikeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveInterneSifarnikeResponse>(null as any);
    }
}

export interface IPromeneIzMaticnihEvidencijaClient {
    /**
     * Pretrag organa po kriterijumima pretrage (objavljeni organi)
     * @param datumOd (optional) 
     * @param datumDo (optional) 
     * @param vrstaPromeneIds (optional) 
     * @param maticnaEvidencijaIds (optional) 
     * @param statusPromene (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getPromeneIzMaticnihEvidencijaPretraga(datumOd?: Date | null | undefined, datumDo?: Date | null | undefined, vrstaPromeneIds?: number[] | null | undefined, maticnaEvidencijaIds?: number[] | null | undefined, statusPromene?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPromenaIzMaticnihEvidencijaResponse>;
    /**
     * Preuzimanje novih promena iz maticne evidencije
     */
    preuzmiNovePromeneIzMaticnihEvidencija(command: PreuzmiNovePromeneIzMaticnihEvidencijaCommand): Observable<PreuzmiNovePromeneResponse>;
    /**
     * Oznaci da promena iz maticne evidencije nive relevanta
     */
    oznaciDaPromenaIzMaticneEvidencijeNijeRelevantna(command: OznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand): Observable<boolean>;
    /**
     * Promeni status promene u Obradjena
     */
    promeniStatusPromeneUObradjena(command: PromeniStatusPromeneUObradjenaCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class PromeneIzMaticnihEvidencijaClient implements IPromeneIzMaticnihEvidencijaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(KI_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9100";
    }

    /**
     * Pretrag organa po kriterijumima pretrage (objavljeni organi)
     * @param datumOd (optional) 
     * @param datumDo (optional) 
     * @param vrstaPromeneIds (optional) 
     * @param maticnaEvidencijaIds (optional) 
     * @param statusPromene (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getPromeneIzMaticnihEvidencijaPretraga(datumOd?: Date | null | undefined, datumDo?: Date | null | undefined, vrstaPromeneIds?: number[] | null | undefined, maticnaEvidencijaIds?: number[] | null | undefined, statusPromene?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPromenaIzMaticnihEvidencijaResponse> {
        let url_ = this.baseUrl + "/api/PromeneIzMaticnihEvidencija/getPromeneIzMaticnihEvidencijaPretraga?";
        if (datumOd !== undefined && datumOd !== null)
            url_ += "DatumOd=" + encodeURIComponent(datumOd ? "" + datumOd.toISOString() : "") + "&";
        if (datumDo !== undefined && datumDo !== null)
            url_ += "DatumDo=" + encodeURIComponent(datumDo ? "" + datumDo.toISOString() : "") + "&";
        if (vrstaPromeneIds !== undefined && vrstaPromeneIds !== null)
            vrstaPromeneIds && vrstaPromeneIds.forEach(item => { url_ += "VrstaPromeneIds=" + encodeURIComponent("" + item) + "&"; });
        if (maticnaEvidencijaIds !== undefined && maticnaEvidencijaIds !== null)
            maticnaEvidencijaIds && maticnaEvidencijaIds.forEach(item => { url_ += "MaticnaEvidencijaIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusPromene !== undefined && statusPromene !== null)
            statusPromene && statusPromene.forEach(item => { url_ += "StatusPromene=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPromeneIzMaticnihEvidencijaPretraga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromeneIzMaticnihEvidencijaPretraga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPromenaIzMaticnihEvidencijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPromenaIzMaticnihEvidencijaResponse>;
        }));
    }

    protected processGetPromeneIzMaticnihEvidencijaPretraga(response: HttpResponseBase): Observable<PagedResponseOfPromenaIzMaticnihEvidencijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfPromenaIzMaticnihEvidencijaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPromenaIzMaticnihEvidencijaResponse>(null as any);
    }

    /**
     * Preuzimanje novih promena iz maticne evidencije
     */
    preuzmiNovePromeneIzMaticnihEvidencija(command: PreuzmiNovePromeneIzMaticnihEvidencijaCommand): Observable<PreuzmiNovePromeneResponse> {
        let url_ = this.baseUrl + "/api/PromeneIzMaticnihEvidencija/preuzmiNovePromeneIzMaticnihEvidencija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPreuzmiNovePromeneIzMaticnihEvidencija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreuzmiNovePromeneIzMaticnihEvidencija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreuzmiNovePromeneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreuzmiNovePromeneResponse>;
        }));
    }

    protected processPreuzmiNovePromeneIzMaticnihEvidencija(response: HttpResponseBase): Observable<PreuzmiNovePromeneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PreuzmiNovePromeneResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreuzmiNovePromeneResponse>(null as any);
    }

    /**
     * Oznaci da promena iz maticne evidencije nive relevanta
     */
    oznaciDaPromenaIzMaticneEvidencijeNijeRelevantna(command: OznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PromeneIzMaticnihEvidencija/oznaciDaPromenaIzMaticneEvidencijeNijeRelevantna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processOznaciDaPromenaIzMaticneEvidencijeNijeRelevantna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOznaciDaPromenaIzMaticneEvidencijeNijeRelevantna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOznaciDaPromenaIzMaticneEvidencijeNijeRelevantna(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * Promeni status promene u Obradjena
     */
    promeniStatusPromeneUObradjena(command: PromeniStatusPromeneUObradjenaCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PromeneIzMaticnihEvidencija/promeniStatusPromeneUObradjena";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPromeniStatusPromeneUObradjena(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromeniStatusPromeneUObradjena(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPromeniStatusPromeneUObradjena(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IMaticneEvidencijeClient {
    /**
     * Izvrsava pretragu po maticnoj evidenciji.
     */
    getOrganPoEvidenciji(query: GetOrganPoEvidencijiCommand): Observable<OrganizacioniEntitet>;
}

@Injectable({
    providedIn: 'root'
})
export class MaticneEvidencijeClient implements IMaticneEvidencijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(KI_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9100";
    }

    /**
     * Izvrsava pretragu po maticnoj evidenciji.
     */
    getOrganPoEvidenciji(query: GetOrganPoEvidencijiCommand): Observable<OrganizacioniEntitet> {
        let url_ = this.baseUrl + "/api/MaticneEvidencije/getOrganPoEvidenciji";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganPoEvidenciji(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganPoEvidenciji(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizacioniEntitet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizacioniEntitet>;
        }));
    }

    protected processGetOrganPoEvidenciji(response: HttpResponseBase): Observable<OrganizacioniEntitet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizacioniEntitet.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizacioniEntitet>(null as any);
    }
}

export interface IKatalogInstitucijaClient {
    /**
     * Kreiranje organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    kreiranjeOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
    /**
     * Kreiranje organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    kreiranjePodredjenogOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
    /**
     * Izmena organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    izmenaOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
    /**
     * Kreiranje nove verzije organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    kreiranjeNoveVerzijeOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
    /**
     * Objavljivanje organa
     */
    objavi(command: ObjaviOrganizacioniEntitetCommand): Observable<GenericActionResponse>;
    /**
     * Objavljivanje organa
     */
    izmeniIObjaviOrgan(command: ObjaviOrganizacioniEntitetCommand): Observable<GenericActionResponse>;
    /**
     * Objavljivanje organa
     */
    kreirajNovuVerzijuIObjaviOrgan(command: ObjaviOrganizacioniEntitetCommand): Observable<GenericActionResponse>;
    /**
     * Dohvatanje organa za izmenu
     * @param sifraOrgana (optional) 
     */
    dajOrgEntitetZaIzmenu(sifraOrgana?: string | null | undefined): Observable<DajOrgEntitetResponse>;
    /**
     * Deaktiviranje organizacionog entiteta
     */
    deaktiviraj(command: DeaktivirajOrganizacioniEntitetCommand): Observable<GenericActionResponse>;
    /**
     * Brisanje organizacionog entiteta
     */
    obrisi(command: ObrisiOrganizacioniEntitetCommand): Observable<GenericActionResponse>;
    /**
     * Pretrag organa po kriterijumima pretrage (moji organi)
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getKorisnikoveOrganizacioneEntitetePoKriterijumuPretrage(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse>;
    /**
     * Pretrag organa po kriterijumima pretrage (objavljeni organi)
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getObjavljeneOrganizacioneEntitetePoKriterijumuPretrage(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse>;
    /**
     * Pretraga organa po identifikacionim podacima
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     */
    pretragaPoIdentifikacionimPodacima(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined): Observable<PretragaPoIdentifikacionimPodacimaResponse>;
    /**
     * Daj sifru organa po identifikacionim podacima
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     */
    dajSifruOrganaPoIdentifikacionimPodacima(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined): Observable<string>;
    /**
     * Dohvatanje svih organa koje korsnik sme da vidi za statuse
     * @param statusi (optional) 
     */
    dajSveKorisnikoveOrganePoStatusu(statusi?: string[] | null | undefined): Observable<DajSveOrganeResponse>;
    /**
     * Dohvatanje svih organa koje korisnik sme da vidi (samo prvi nivo iz tokena) 
    za dropdwon ,,U sastavu organa'' - dodavanje novog organa
     * @param statusi (optional) 
     */
    dajSveKorisnikoveOrganePrvogNivoaPoStatusu(statusi?: string[] | null | undefined): Observable<DajSveOrganeResponse>;
    /**
     * Dohvatanje svih organa koje korisnik sme da vidi - ako nema nijedan u tokenu kako bi mogao da izabere 
    za dropdwon ,,U sastavu organa'' - dodavanje novog organa
     * @param naziv (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    dajOrganeNadredjeneOrganizacionimJedinicama(naziv?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfOrganResponse>;
    /**
     * Dohvatanje svih objavljenih organa (dropdwon ,,U sastavu organa'')
    Objavljeni i Ceka aktiviranje
     * @param query (optional) 
     */
    dajSveObjavljeneOrgane(query?: DajSveObjavljeneOrganeQuery | null | undefined): Observable<DajSveOrganeResponse>;
    /**
     * Dohvatanje svih objavljenih aktivni organa
    Katalog postupaka
     * @param query (optional) 
     */
    dajSveAktivneKorisnikoveOrgane(query?: DajSveAktivneKorisnikoveOrgane | null | undefined): Observable<DajSveOrganeResponse>;
    /**
     * Prikaz organizacione strukture organa (moji organi, tab - organizaciona struktura)
     * @param sifraOrgana (optional) 
     */
    dajOrganizacionuStrukturuOrgana(sifraOrgana?: string | null | undefined): Observable<DajOrganizacionuStrukturuOrganaResponse>;
    /**
     * Prikaz objavljene organizacione strukture organa (objavljeni organi, tab - organizaciona struktura)
     * @param sifraOrgana (optional) 
     */
    dajObjavljenuOrganizacionuStrukturuOrgana(sifraOrgana?: string | null | undefined): Observable<DajOrganizacionuStrukturuOrganaResponse>;
    /**
     * Prikaz organa u sastavu zadatog organa (samo prvi nivo, moji organi)
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajOrganeUSastavu(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOrgEntiteteUSastavuResponse>;
    /**
     * Prikaz objavljenih organa u sastavu zadatog organa (samo prvi nivo, objavljeni organi)
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajObjavljeneOrganeUSastavu(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOrgEntiteteUSastavuResponse>;
    /**
     * Prikaz svih verzija organa svih statusa (moji-organi)
     * @param sifra (optional) 
     */
    dajSveVerzijeOrgana(sifra?: string | null | undefined): Observable<DajSveVerzijeOrganaResponse>;
    /**
     * Prikaz svih verzija organa bez verzija u pripremi (objavljeni organi)
     * @param sifra (optional) 
     */
    dajSveVerzijeOrganaBezUPripremi(sifra?: string | null | undefined): Observable<DajSveVerzijeOrganaResponse>;
    /**
     * Dohvtanje aktuelne verzije organa u zavisnosti od statusa organa
     * @param sifra (optional) 
     */
    dajAktuelnuVerzijuOrganaPoSifri(sifra?: string | null | undefined): Observable<DajOrgEntitetResponse>;
    /**
     * Prikaz svih verzija organa
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajOdredjenuVerzijuOrgana(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOrgEntitetResponse>;
    /**
     * Pre cuvanja/objave organa proverava se validnost unetih identifikacionih podataka
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param sifraOrgana (optional) 
     */
    proveriValidnostIdentifikacionihPodataka(maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, sifraOrgana?: string | null | undefined): Observable<GenericActionResponse>;
    /**
     * Izvoz rezultata pretrage organa u excel (moji orani)
     * @param lang (optional) 
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozKorisnikovihOrganaUExcel(lang?: string | null | undefined, maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string>;
    /**
     * Izvoz rezultata pretrage objavljenih organa u excel (objavljeni organi)
     * @param lang (optional) 
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozObjavljenihOrganaUExcel(lang?: string | null | undefined, maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string>;
    /**
     * Vracanje organa iz statusa Ceka upis u katalog u Podaci u pripremi
     */
    povratakOrganaNaStatusUPripremi(command: PovratakOrganaNaStatusUPripremiCommand): Observable<GenericActionResponse>;
    /**
     * Dohvatanje svih korisnikovih organa po statusu i operaciji
    Katalog postupaka
     * @param statusi (optional) 
     * @param operacija (optional) 
     */
    dajSveKorisnikoveOrganePoStatusuIOperaciji(statusi?: string[] | null | undefined, operacija?: string | null | undefined): Observable<DajSveOrganeResponse>;
    /**
     * Pretraga organizacionih jedinica po kriterijumima pretrage
     * @param sifraOrgana (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param jBKJS (optional) 
     * @param sistemskaSifra (optional) 
     * @param nadleznaOrganizacionaJedinicaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getOJPoKriterijumuPretrage(sifraOrgana?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, jBKJS?: string | null | undefined, sistemskaSifra?: string | null | undefined, nadleznaOrganizacionaJedinicaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPretragaOJResponse>;
    /**
     * Sve sme deaktiviranih OJ u sastavu organa
     * @param sifraOrgana (optional) 
     */
    dajOJUSastavuOrgana(sifraOrgana?: string | null | undefined): Observable<DajOJUSastavuOrganaResponse>;
    /**
     * Aktivne OJ u sastavu organa
    Katalog postupaka
     * @param sifraOrgana (optional) 
     */
    dajAktivneOJuSastavu(sifraOrgana?: string | null | undefined): Observable<DajOJUSastavuOrganaResponse>;
    /**
     * Snimanje organizacione jedinice
     */
    kreiranjeOJ(command: SacuvajOrganizacionuJedinicuCommand): Observable<GenericActionResponse>;
    /**
     * Snimanje organizacione jedinice
     */
    izmenaOJ(command: SacuvajOrganizacionuJedinicuCommand): Observable<GenericActionResponse>;
    /**
     * Snimanje organizacione jedinice
     */
    kreiranjeNoveVerzijeOJ(command: SacuvajOrganizacionuJedinicuCommand): Observable<GenericActionResponse>;
    /**
     * Dohvatanje org.jedinice za izmenu
     * @param sistemskaSifra (optional) 
     * @param verzija (optional) 
     */
    dajOJZaIzmenu(sistemskaSifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOJResponse>;
    /**
     * Objava organizacione jedinice
     */
    objaviOJ(command: ObjaviOJCommand): Observable<GenericActionResponse>;
    /**
     * Objavljivanje organa
     */
    izmeniIObjaviOJ(command: ObjaviOJCommand): Observable<GenericActionResponse>;
    /**
     * Objavljivanje organa
     */
    kreirajNovuVerzijuIObjaviOJ(command: ObjaviOJCommand): Observable<GenericActionResponse>;
    /**
     * Izvoz rezultata pretrage orgnaizacionih jedinica u excel
     * @param lang (optional) 
     * @param sifraOrgana (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param jBKJS (optional) 
     * @param sistemskaSifra (optional) 
     * @param nadleznaOrganizacionaJedinicaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozOJUExcel(lang?: string | null | undefined, sifraOrgana?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, jBKJS?: string | null | undefined, sistemskaSifra?: string | null | undefined, nadleznaOrganizacionaJedinicaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string>;
    /**
     * Brisanje organizacione jedinice
     */
    obrisiOJ(command: ObrisiOJCommand): Observable<GenericActionResponse>;
    /**
     * Deaktiviranje organizacione jedinice
     */
    deaktivirajOJ(command: DeaktivirajOJCommand): Observable<GenericActionResponse>;
    /**
     * Prikaz svih verzija organizacione jedinice
     * @param sistemskaSifra (optional) 
     */
    dajSveVerzijeOJ(sistemskaSifra?: string | null | undefined): Observable<DajSveVerzijeOJResponse>;
    /**
     * Vracanje OJ iz statusa Ceka upis u katalog u Podaci u pripremi
     */
    povratakOJNaStatusUPripremi(command: PovratakOJNaStatusUPripremiCommand): Observable<GenericActionResponse>;
    /**
     * Dohvatanje svih organizacionih entiteta (objavljenih i aktivnih)
    Za kataloga postupaka
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param sistemskaSifra (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param kategorija (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    dajSveAktivneObjavljeneEntitete(maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, sistemskaSifra?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, kategorija?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfDajSveAktivneObjavljeneEntitetResponse>;
    /**
     * Pretraga svih organizacionih entiteta po kriterijumima pretrage
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param sistemskaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param kategorija (optional) 
     * @param sifraNadleznogOrgana (optional) 
     * @param sifreIzabranihEntiteta (optional) 
     * @param statusi (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    objedinjenaPretragaEntiteta(maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, sistemskaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, kategorija?: string | null | undefined, sifraNadleznogOrgana?: string | null | undefined, sifreIzabranihEntiteta?: string[] | null | undefined, statusi?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfObjedinjenaPretragaEntitetaResponse>;
    /**
     * Izvoz rezultata objedinjene pretrage orgnaizacionih entiteta u excel
     * @param lang (optional) 
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param sistemskaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param kategorija (optional) 
     * @param sifraNadleznogOrgana (optional) 
     * @param sifreIzabranihEntiteta (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozObjedinjenePretrageUExcel(lang?: string | null | undefined, maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, sistemskaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, kategorija?: string | null | undefined, sifraNadleznogOrgana?: string | null | undefined, sifreIzabranihEntiteta?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string>;
    /**
     * Pretraga organizacionih entiteta po nazivu za popunjavanje autocomplete polja, kako ne bismo dovlacili sve
    Omogucena je pretraga organa, organizacionih jedinica i svih entiteta
     * @param naziv (optional) 
     * @param vrstaEntiteta (optional) 
     * @param statusi (optional) 
     * @param operacija (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     * @param operacijePoKompanijiFlag (optional) 
     */
    pretragaOrganizacionihEntitetaPoNazivu(naziv?: string | null | undefined, vrstaEntiteta?: number | undefined, statusi?: string[] | null | undefined, operacija?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined, operacijePoKompanijiFlag?: boolean | null | undefined): Observable<PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse>;
    /**
     * Pretraga organizacionih entiteta na objedinjenoj pretrazi na nadleznosti, za katalog postupaka
    Omogucena je pretraga organa i organizacionih jedinica
     * @param naziv (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param vrstaEntiteta (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    pretragaOENadleznosti(naziv?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, vrstaEntiteta?: number | undefined, nadlezniOrganSifra?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfOrganizacioniEntitetNadleznostiResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class KatalogInstitucijaClient implements IKatalogInstitucijaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(KI_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9100";
    }

    /**
     * Kreiranje organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    kreiranjeOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/kreiranjeOrgana";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreiranjeOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreiranjeOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
        }));
    }

    protected processKreiranjeOrgana(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfOrganizacioniEntitet.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>(null as any);
    }

    /**
     * Kreiranje organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    kreiranjePodredjenogOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/kreiranjePodredjenogOrgana";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreiranjePodredjenogOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreiranjePodredjenogOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
        }));
    }

    protected processKreiranjePodredjenogOrgana(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfOrganizacioniEntitet.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>(null as any);
    }

    /**
     * Izmena organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    izmenaOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izmenaOrgana";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzmenaOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmenaOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
        }));
    }

    protected processIzmenaOrgana(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfOrganizacioniEntitet.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>(null as any);
    }

    /**
     * Kreiranje nove verzije organa - SacuvajOrganizacioniEntitetCommandHandler
     */
    kreiranjeNoveVerzijeOrgana(command: SacuvajOrganizacioniEntitetCommand): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/kreiranjeNoveVerzijeOrgana";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreiranjeNoveVerzijeOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreiranjeNoveVerzijeOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>;
        }));
    }

    protected processKreiranjeNoveVerzijeOrgana(response: HttpResponseBase): Observable<GenericActionResponseWithItemsKIOfOrganizacioniEntitet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponseWithItemsKIOfOrganizacioniEntitet.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsKIOfOrganizacioniEntitet>(null as any);
    }

    /**
     * Objavljivanje organa
     */
    objavi(command: ObjaviOrganizacioniEntitetCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/objaviOrgan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObjavi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjavi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processObjavi(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Objavljivanje organa
     */
    izmeniIObjaviOrgan(command: ObjaviOrganizacioniEntitetCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izmeniIObjaviOrgan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzmeniIObjaviOrgan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmeniIObjaviOrgan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processIzmeniIObjaviOrgan(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Objavljivanje organa
     */
    kreirajNovuVerzijuIObjaviOrgan(command: ObjaviOrganizacioniEntitetCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/kreirajNovuVerzijuIObjaviOrgan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreirajNovuVerzijuIObjaviOrgan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajNovuVerzijuIObjaviOrgan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processKreirajNovuVerzijuIObjaviOrgan(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Dohvatanje organa za izmenu
     * @param sifraOrgana (optional) 
     */
    dajOrgEntitetZaIzmenu(sifraOrgana?: string | null | undefined): Observable<DajOrgEntitetResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajOrgEntitetZaIzmenu?";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajOrgEntitetZaIzmenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajOrgEntitetZaIzmenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOrgEntitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOrgEntitetResponse>;
        }));
    }

    protected processDajOrgEntitetZaIzmenu(response: HttpResponseBase): Observable<DajOrgEntitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOrgEntitetResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOrgEntitetResponse>(null as any);
    }

    /**
     * Deaktiviranje organizacionog entiteta
     */
    deaktiviraj(command: DeaktivirajOrganizacioniEntitetCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/deaktivirajEntitet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeaktiviraj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktiviraj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processDeaktiviraj(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Brisanje organizacionog entiteta
     */
    obrisi(command: ObrisiOrganizacioniEntitetCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/obrisiEntitet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObrisi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processObrisi(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Pretrag organa po kriterijumima pretrage (moji organi)
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getKorisnikoveOrganizacioneEntitetePoKriterijumuPretrage(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/getKorisnikoveEntitetePoKriterijumu?";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (sifraDrzave !== undefined && sifraDrzave !== null)
            url_ += "SifraDrzave=" + encodeURIComponent("" + sifraDrzave) + "&";
        if (sifraOpstine !== undefined && sifraOpstine !== null)
            url_ += "SifraOpstine=" + encodeURIComponent("" + sifraOpstine) + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (nadlezniOrganSifra !== undefined && nadlezniOrganSifra !== null)
            url_ += "NadlezniOrganSifra=" + encodeURIComponent("" + nadlezniOrganSifra) + "&";
        if (punNazivOrgana !== undefined && punNazivOrgana !== null)
            url_ += "PunNazivOrgana=" + encodeURIComponent("" + punNazivOrgana) + "&";
        if (skraceniNazivOrgana !== undefined && skraceniNazivOrgana !== null)
            url_ += "SkraceniNazivOrgana=" + encodeURIComponent("" + skraceniNazivOrgana) + "&";
        if (vrstaOrganaSifra !== undefined && vrstaOrganaSifra !== null)
            url_ += "VrstaOrganaSifra=" + encodeURIComponent("" + vrstaOrganaSifra) + "&";
        if (vrstaTeritorijalneNadleznostiSifra !== undefined && vrstaTeritorijalneNadleznostiSifra !== null)
            url_ += "VrstaTeritorijalneNadleznostiSifra=" + encodeURIComponent("" + vrstaTeritorijalneNadleznostiSifra) + "&";
        if (sifreOblikaSvojine !== undefined && sifreOblikaSvojine !== null)
            sifreOblikaSvojine && sifreOblikaSvojine.forEach(item => { url_ += "SifreOblikaSvojine=" + encodeURIComponent("" + item) + "&"; });
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetKorisnikoveOrganizacioneEntitetePoKriterijumuPretrage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKorisnikoveOrganizacioneEntitetePoKriterijumuPretrage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse>;
        }));
    }

    protected processGetKorisnikoveOrganizacioneEntitetePoKriterijumuPretrage(response: HttpResponseBase): Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfPretragaOrganizacionihEntitetaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaOrganizacionihEntitetaResponse>(null as any);
    }

    /**
     * Pretrag organa po kriterijumima pretrage (objavljeni organi)
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getObjavljeneOrganizacioneEntitetePoKriterijumuPretrage(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/getObjavljeneEntitetePoKriterijumu?";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (sifraDrzave !== undefined && sifraDrzave !== null)
            url_ += "SifraDrzave=" + encodeURIComponent("" + sifraDrzave) + "&";
        if (sifraOpstine !== undefined && sifraOpstine !== null)
            url_ += "SifraOpstine=" + encodeURIComponent("" + sifraOpstine) + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (nadlezniOrganSifra !== undefined && nadlezniOrganSifra !== null)
            url_ += "NadlezniOrganSifra=" + encodeURIComponent("" + nadlezniOrganSifra) + "&";
        if (punNazivOrgana !== undefined && punNazivOrgana !== null)
            url_ += "PunNazivOrgana=" + encodeURIComponent("" + punNazivOrgana) + "&";
        if (skraceniNazivOrgana !== undefined && skraceniNazivOrgana !== null)
            url_ += "SkraceniNazivOrgana=" + encodeURIComponent("" + skraceniNazivOrgana) + "&";
        if (vrstaOrganaSifra !== undefined && vrstaOrganaSifra !== null)
            url_ += "VrstaOrganaSifra=" + encodeURIComponent("" + vrstaOrganaSifra) + "&";
        if (vrstaTeritorijalneNadleznostiSifra !== undefined && vrstaTeritorijalneNadleznostiSifra !== null)
            url_ += "VrstaTeritorijalneNadleznostiSifra=" + encodeURIComponent("" + vrstaTeritorijalneNadleznostiSifra) + "&";
        if (sifreOblikaSvojine !== undefined && sifreOblikaSvojine !== null)
            sifreOblikaSvojine && sifreOblikaSvojine.forEach(item => { url_ += "SifreOblikaSvojine=" + encodeURIComponent("" + item) + "&"; });
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetObjavljeneOrganizacioneEntitetePoKriterijumuPretrage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObjavljeneOrganizacioneEntitetePoKriterijumuPretrage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse>;
        }));
    }

    protected processGetObjavljeneOrganizacioneEntitetePoKriterijumuPretrage(response: HttpResponseBase): Observable<PagedResponseOfPretragaOrganizacionihEntitetaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfPretragaOrganizacionihEntitetaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaOrganizacionihEntitetaResponse>(null as any);
    }

    /**
     * Pretraga organa po identifikacionim podacima
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     */
    pretragaPoIdentifikacionimPodacima(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined): Observable<PretragaPoIdentifikacionimPodacimaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/pretragaPoIdentifikacionimPodacima?";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPretragaPoIdentifikacionimPodacima(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaPoIdentifikacionimPodacima(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PretragaPoIdentifikacionimPodacimaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PretragaPoIdentifikacionimPodacimaResponse>;
        }));
    }

    protected processPretragaPoIdentifikacionimPodacima(response: HttpResponseBase): Observable<PretragaPoIdentifikacionimPodacimaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PretragaPoIdentifikacionimPodacimaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PretragaPoIdentifikacionimPodacimaResponse>(null as any);
    }

    /**
     * Daj sifru organa po identifikacionim podacima
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     */
    dajSifruOrganaPoIdentifikacionimPodacima(maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSifruOrgana?";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSifruOrganaPoIdentifikacionimPodacima(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSifruOrganaPoIdentifikacionimPodacima(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDajSifruOrganaPoIdentifikacionimPodacima(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Dohvatanje svih organa koje korsnik sme da vidi za statuse
     * @param statusi (optional) 
     */
    dajSveKorisnikoveOrganePoStatusu(statusi?: string[] | null | undefined): Observable<DajSveOrganeResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveKorisnikoveOrganePoStatusu?";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveKorisnikoveOrganePoStatusu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveKorisnikoveOrganePoStatusu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveOrganeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveOrganeResponse>;
        }));
    }

    protected processDajSveKorisnikoveOrganePoStatusu(response: HttpResponseBase): Observable<DajSveOrganeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveOrganeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveOrganeResponse>(null as any);
    }

    /**
     * Dohvatanje svih organa koje korisnik sme da vidi (samo prvi nivo iz tokena) 
    za dropdwon ,,U sastavu organa'' - dodavanje novog organa
     * @param statusi (optional) 
     */
    dajSveKorisnikoveOrganePrvogNivoaPoStatusu(statusi?: string[] | null | undefined): Observable<DajSveOrganeResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveKorisnikoveOrganePrvogNivoaPoStatusu?";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveKorisnikoveOrganePrvogNivoaPoStatusu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveKorisnikoveOrganePrvogNivoaPoStatusu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveOrganeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveOrganeResponse>;
        }));
    }

    protected processDajSveKorisnikoveOrganePrvogNivoaPoStatusu(response: HttpResponseBase): Observable<DajSveOrganeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveOrganeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveOrganeResponse>(null as any);
    }

    /**
     * Dohvatanje svih organa koje korisnik sme da vidi - ako nema nijedan u tokenu kako bi mogao da izabere 
    za dropdwon ,,U sastavu organa'' - dodavanje novog organa
     * @param naziv (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    dajOrganeNadredjeneOrganizacionimJedinicama(naziv?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfOrganResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajOrganeNadredjeneOrganizacionimJedinicama?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajOrganeNadredjeneOrganizacionimJedinicama(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajOrganeNadredjeneOrganizacionimJedinicama(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfOrganResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfOrganResponse>;
        }));
    }

    protected processDajOrganeNadredjeneOrganizacionimJedinicama(response: HttpResponseBase): Observable<PagedResponseOfOrganResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfOrganResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfOrganResponse>(null as any);
    }

    /**
     * Dohvatanje svih objavljenih organa (dropdwon ,,U sastavu organa'')
    Objavljeni i Ceka aktiviranje
     * @param query (optional) 
     */
    dajSveObjavljeneOrgane(query?: DajSveObjavljeneOrganeQuery | null | undefined): Observable<DajSveOrganeResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveObjavljeneOrgane?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveObjavljeneOrgane(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveObjavljeneOrgane(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveOrganeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveOrganeResponse>;
        }));
    }

    protected processDajSveObjavljeneOrgane(response: HttpResponseBase): Observable<DajSveOrganeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveOrganeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveOrganeResponse>(null as any);
    }

    /**
     * Dohvatanje svih objavljenih aktivni organa
    Katalog postupaka
     * @param query (optional) 
     */
    dajSveAktivneKorisnikoveOrgane(query?: DajSveAktivneKorisnikoveOrgane | null | undefined): Observable<DajSveOrganeResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveAktivneKorisnikoveOrgane?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveAktivneKorisnikoveOrgane(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveAktivneKorisnikoveOrgane(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveOrganeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveOrganeResponse>;
        }));
    }

    protected processDajSveAktivneKorisnikoveOrgane(response: HttpResponseBase): Observable<DajSveOrganeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveOrganeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveOrganeResponse>(null as any);
    }

    /**
     * Prikaz organizacione strukture organa (moji organi, tab - organizaciona struktura)
     * @param sifraOrgana (optional) 
     */
    dajOrganizacionuStrukturuOrgana(sifraOrgana?: string | null | undefined): Observable<DajOrganizacionuStrukturuOrganaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajOrganizacionuStrukturuOrgana?";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajOrganizacionuStrukturuOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajOrganizacionuStrukturuOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOrganizacionuStrukturuOrganaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOrganizacionuStrukturuOrganaResponse>;
        }));
    }

    protected processDajOrganizacionuStrukturuOrgana(response: HttpResponseBase): Observable<DajOrganizacionuStrukturuOrganaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOrganizacionuStrukturuOrganaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOrganizacionuStrukturuOrganaResponse>(null as any);
    }

    /**
     * Prikaz objavljene organizacione strukture organa (objavljeni organi, tab - organizaciona struktura)
     * @param sifraOrgana (optional) 
     */
    dajObjavljenuOrganizacionuStrukturuOrgana(sifraOrgana?: string | null | undefined): Observable<DajOrganizacionuStrukturuOrganaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajObjavljenuOrganizacionuStrukturuOrgana?";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajObjavljenuOrganizacionuStrukturuOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajObjavljenuOrganizacionuStrukturuOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOrganizacionuStrukturuOrganaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOrganizacionuStrukturuOrganaResponse>;
        }));
    }

    protected processDajObjavljenuOrganizacionuStrukturuOrgana(response: HttpResponseBase): Observable<DajOrganizacionuStrukturuOrganaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOrganizacionuStrukturuOrganaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOrganizacionuStrukturuOrganaResponse>(null as any);
    }

    /**
     * Prikaz organa u sastavu zadatog organa (samo prvi nivo, moji organi)
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajOrganeUSastavu(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOrgEntiteteUSastavuResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajOrganeUSastavu?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajOrganeUSastavu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajOrganeUSastavu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOrgEntiteteUSastavuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOrgEntiteteUSastavuResponse>;
        }));
    }

    protected processDajOrganeUSastavu(response: HttpResponseBase): Observable<DajOrgEntiteteUSastavuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOrgEntiteteUSastavuResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOrgEntiteteUSastavuResponse>(null as any);
    }

    /**
     * Prikaz objavljenih organa u sastavu zadatog organa (samo prvi nivo, objavljeni organi)
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajObjavljeneOrganeUSastavu(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOrgEntiteteUSastavuResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajObjavljeneOrganeUSastavu?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajObjavljeneOrganeUSastavu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajObjavljeneOrganeUSastavu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOrgEntiteteUSastavuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOrgEntiteteUSastavuResponse>;
        }));
    }

    protected processDajObjavljeneOrganeUSastavu(response: HttpResponseBase): Observable<DajOrgEntiteteUSastavuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOrgEntiteteUSastavuResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOrgEntiteteUSastavuResponse>(null as any);
    }

    /**
     * Prikaz svih verzija organa svih statusa (moji-organi)
     * @param sifra (optional) 
     */
    dajSveVerzijeOrgana(sifra?: string | null | undefined): Observable<DajSveVerzijeOrganaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveVerzijeOrgana?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveVerzijeOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveVerzijeOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveVerzijeOrganaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveVerzijeOrganaResponse>;
        }));
    }

    protected processDajSveVerzijeOrgana(response: HttpResponseBase): Observable<DajSveVerzijeOrganaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveVerzijeOrganaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveVerzijeOrganaResponse>(null as any);
    }

    /**
     * Prikaz svih verzija organa bez verzija u pripremi (objavljeni organi)
     * @param sifra (optional) 
     */
    dajSveVerzijeOrganaBezUPripremi(sifra?: string | null | undefined): Observable<DajSveVerzijeOrganaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveVerzijeOrganaBezUPripremi?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveVerzijeOrganaBezUPripremi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveVerzijeOrganaBezUPripremi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveVerzijeOrganaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveVerzijeOrganaResponse>;
        }));
    }

    protected processDajSveVerzijeOrganaBezUPripremi(response: HttpResponseBase): Observable<DajSveVerzijeOrganaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveVerzijeOrganaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveVerzijeOrganaResponse>(null as any);
    }

    /**
     * Dohvtanje aktuelne verzije organa u zavisnosti od statusa organa
     * @param sifra (optional) 
     */
    dajAktuelnuVerzijuOrganaPoSifri(sifra?: string | null | undefined): Observable<DajOrgEntitetResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajAktuelnuVerzijuOrganaPoSifri?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajAktuelnuVerzijuOrganaPoSifri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajAktuelnuVerzijuOrganaPoSifri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOrgEntitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOrgEntitetResponse>;
        }));
    }

    protected processDajAktuelnuVerzijuOrganaPoSifri(response: HttpResponseBase): Observable<DajOrgEntitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOrgEntitetResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOrgEntitetResponse>(null as any);
    }

    /**
     * Prikaz svih verzija organa
     * @param sifra (optional) 
     * @param verzija (optional) 
     */
    dajOdredjenuVerzijuOrgana(sifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOrgEntitetResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajOdredjenuVerzijuOrgana?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajOdredjenuVerzijuOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajOdredjenuVerzijuOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOrgEntitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOrgEntitetResponse>;
        }));
    }

    protected processDajOdredjenuVerzijuOrgana(response: HttpResponseBase): Observable<DajOrgEntitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOrgEntitetResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOrgEntitetResponse>(null as any);
    }

    /**
     * Pre cuvanja/objave organa proverava se validnost unetih identifikacionih podataka
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param sifraOrgana (optional) 
     */
    proveriValidnostIdentifikacionihPodataka(maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, sifraOrgana?: string | null | undefined): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/proveriValidnostIdentifikacionihPodataka?";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProveriValidnostIdentifikacionihPodataka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProveriValidnostIdentifikacionihPodataka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processProveriValidnostIdentifikacionihPodataka(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Izvoz rezultata pretrage organa u excel (moji orani)
     * @param lang (optional) 
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozKorisnikovihOrganaUExcel(lang?: string | null | undefined, maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izvozKorisnikovihOrganaUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (sifraDrzave !== undefined && sifraDrzave !== null)
            url_ += "SifraDrzave=" + encodeURIComponent("" + sifraDrzave) + "&";
        if (sifraOpstine !== undefined && sifraOpstine !== null)
            url_ += "SifraOpstine=" + encodeURIComponent("" + sifraOpstine) + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (nadlezniOrganSifra !== undefined && nadlezniOrganSifra !== null)
            url_ += "NadlezniOrganSifra=" + encodeURIComponent("" + nadlezniOrganSifra) + "&";
        if (punNazivOrgana !== undefined && punNazivOrgana !== null)
            url_ += "PunNazivOrgana=" + encodeURIComponent("" + punNazivOrgana) + "&";
        if (skraceniNazivOrgana !== undefined && skraceniNazivOrgana !== null)
            url_ += "SkraceniNazivOrgana=" + encodeURIComponent("" + skraceniNazivOrgana) + "&";
        if (vrstaOrganaSifra !== undefined && vrstaOrganaSifra !== null)
            url_ += "VrstaOrganaSifra=" + encodeURIComponent("" + vrstaOrganaSifra) + "&";
        if (vrstaTeritorijalneNadleznostiSifra !== undefined && vrstaTeritorijalneNadleznostiSifra !== null)
            url_ += "VrstaTeritorijalneNadleznostiSifra=" + encodeURIComponent("" + vrstaTeritorijalneNadleznostiSifra) + "&";
        if (sifreOblikaSvojine !== undefined && sifreOblikaSvojine !== null)
            sifreOblikaSvojine && sifreOblikaSvojine.forEach(item => { url_ += "SifreOblikaSvojine=" + encodeURIComponent("" + item) + "&"; });
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzvozKorisnikovihOrganaUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozKorisnikovihOrganaUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozKorisnikovihOrganaUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Izvoz rezultata pretrage objavljenih organa u excel (objavljeni organi)
     * @param lang (optional) 
     * @param maticniBroj (optional) 
     * @param jBKJS (optional) 
     * @param pIB (optional) 
     * @param statusi (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param sifraOrgana (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param punNazivOrgana (optional) 
     * @param skraceniNazivOrgana (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifreOblikaSvojine (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozObjavljenihOrganaUExcel(lang?: string | null | undefined, maticniBroj?: string | null | undefined, jBKJS?: string | null | undefined, pIB?: string | null | undefined, statusi?: string[] | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, sifraOrgana?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, punNazivOrgana?: string | null | undefined, skraceniNazivOrgana?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifreOblikaSvojine?: string[] | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izvozObjavljenihOrganaUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (sifraDrzave !== undefined && sifraDrzave !== null)
            url_ += "SifraDrzave=" + encodeURIComponent("" + sifraDrzave) + "&";
        if (sifraOpstine !== undefined && sifraOpstine !== null)
            url_ += "SifraOpstine=" + encodeURIComponent("" + sifraOpstine) + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (nadlezniOrganSifra !== undefined && nadlezniOrganSifra !== null)
            url_ += "NadlezniOrganSifra=" + encodeURIComponent("" + nadlezniOrganSifra) + "&";
        if (punNazivOrgana !== undefined && punNazivOrgana !== null)
            url_ += "PunNazivOrgana=" + encodeURIComponent("" + punNazivOrgana) + "&";
        if (skraceniNazivOrgana !== undefined && skraceniNazivOrgana !== null)
            url_ += "SkraceniNazivOrgana=" + encodeURIComponent("" + skraceniNazivOrgana) + "&";
        if (vrstaOrganaSifra !== undefined && vrstaOrganaSifra !== null)
            url_ += "VrstaOrganaSifra=" + encodeURIComponent("" + vrstaOrganaSifra) + "&";
        if (vrstaTeritorijalneNadleznostiSifra !== undefined && vrstaTeritorijalneNadleznostiSifra !== null)
            url_ += "VrstaTeritorijalneNadleznostiSifra=" + encodeURIComponent("" + vrstaTeritorijalneNadleznostiSifra) + "&";
        if (sifreOblikaSvojine !== undefined && sifreOblikaSvojine !== null)
            sifreOblikaSvojine && sifreOblikaSvojine.forEach(item => { url_ += "SifreOblikaSvojine=" + encodeURIComponent("" + item) + "&"; });
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzvozObjavljenihOrganaUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozObjavljenihOrganaUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozObjavljenihOrganaUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Vracanje organa iz statusa Ceka upis u katalog u Podaci u pripremi
     */
    povratakOrganaNaStatusUPripremi(command: PovratakOrganaNaStatusUPripremiCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/povratakOrganaNaStatusUPripremi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPovratakOrganaNaStatusUPripremi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPovratakOrganaNaStatusUPripremi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processPovratakOrganaNaStatusUPripremi(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Dohvatanje svih korisnikovih organa po statusu i operaciji
    Katalog postupaka
     * @param statusi (optional) 
     * @param operacija (optional) 
     */
    dajSveKorisnikoveOrganePoStatusuIOperaciji(statusi?: string[] | null | undefined, operacija?: string | null | undefined): Observable<DajSveOrganeResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveKorisnikoveOrganePoStatusuIOperaciji?";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (operacija !== undefined && operacija !== null)
            url_ += "Operacija=" + encodeURIComponent("" + operacija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveKorisnikoveOrganePoStatusuIOperaciji(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveKorisnikoveOrganePoStatusuIOperaciji(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveOrganeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveOrganeResponse>;
        }));
    }

    protected processDajSveKorisnikoveOrganePoStatusuIOperaciji(response: HttpResponseBase): Observable<DajSveOrganeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveOrganeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveOrganeResponse>(null as any);
    }

    /**
     * Pretraga organizacionih jedinica po kriterijumima pretrage
     * @param sifraOrgana (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param jBKJS (optional) 
     * @param sistemskaSifra (optional) 
     * @param nadleznaOrganizacionaJedinicaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    getOJPoKriterijumuPretrage(sifraOrgana?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, jBKJS?: string | null | undefined, sistemskaSifra?: string | null | undefined, nadleznaOrganizacionaJedinicaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfPretragaOJResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/getOJPoKriterijumu?";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (sifraOrganizacioneJedinice !== undefined && sifraOrganizacioneJedinice !== null)
            url_ += "SifraOrganizacioneJedinice=" + encodeURIComponent("" + sifraOrganizacioneJedinice) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (sistemskaSifra !== undefined && sistemskaSifra !== null)
            url_ += "SistemskaSifra=" + encodeURIComponent("" + sistemskaSifra) + "&";
        if (nadleznaOrganizacionaJedinicaSifra !== undefined && nadleznaOrganizacionaJedinicaSifra !== null)
            url_ += "NadleznaOrganizacionaJedinicaSifra=" + encodeURIComponent("" + nadleznaOrganizacionaJedinicaSifra) + "&";
        if (vrstaOrganizacioneJediniceSifra !== undefined && vrstaOrganizacioneJediniceSifra !== null)
            url_ += "VrstaOrganizacioneJediniceSifra=" + encodeURIComponent("" + vrstaOrganizacioneJediniceSifra) + "&";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (skraceniNaziv !== undefined && skraceniNaziv !== null)
            url_ += "SkraceniNaziv=" + encodeURIComponent("" + skraceniNaziv) + "&";
        if (sifraDrzave !== undefined && sifraDrzave !== null)
            url_ += "SifraDrzave=" + encodeURIComponent("" + sifraDrzave) + "&";
        if (sifraOpstine !== undefined && sifraOpstine !== null)
            url_ += "SifraOpstine=" + encodeURIComponent("" + sifraOpstine) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOJPoKriterijumuPretrage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOJPoKriterijumuPretrage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaOJResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaOJResponse>;
        }));
    }

    protected processGetOJPoKriterijumuPretrage(response: HttpResponseBase): Observable<PagedResponseOfPretragaOJResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfPretragaOJResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaOJResponse>(null as any);
    }

    /**
     * Sve sme deaktiviranih OJ u sastavu organa
     * @param sifraOrgana (optional) 
     */
    dajOJUSastavuOrgana(sifraOrgana?: string | null | undefined): Observable<DajOJUSastavuOrganaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajOJuSastavu?";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajOJUSastavuOrgana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajOJUSastavuOrgana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOJUSastavuOrganaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOJUSastavuOrganaResponse>;
        }));
    }

    protected processDajOJUSastavuOrgana(response: HttpResponseBase): Observable<DajOJUSastavuOrganaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOJUSastavuOrganaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOJUSastavuOrganaResponse>(null as any);
    }

    /**
     * Aktivne OJ u sastavu organa
    Katalog postupaka
     * @param sifraOrgana (optional) 
     */
    dajAktivneOJuSastavu(sifraOrgana?: string | null | undefined): Observable<DajOJUSastavuOrganaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajAktivneOJuSastavu?";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajAktivneOJuSastavu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajAktivneOJuSastavu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOJUSastavuOrganaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOJUSastavuOrganaResponse>;
        }));
    }

    protected processDajAktivneOJuSastavu(response: HttpResponseBase): Observable<DajOJUSastavuOrganaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOJUSastavuOrganaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOJUSastavuOrganaResponse>(null as any);
    }

    /**
     * Snimanje organizacione jedinice
     */
    kreiranjeOJ(command: SacuvajOrganizacionuJedinicuCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/kreiranjeOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreiranjeOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreiranjeOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processKreiranjeOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Snimanje organizacione jedinice
     */
    izmenaOJ(command: SacuvajOrganizacionuJedinicuCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izmenaOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzmenaOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmenaOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processIzmenaOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Snimanje organizacione jedinice
     */
    kreiranjeNoveVerzijeOJ(command: SacuvajOrganizacionuJedinicuCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/kreiranjeNoveVerzijeOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreiranjeNoveVerzijeOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreiranjeNoveVerzijeOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processKreiranjeNoveVerzijeOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Dohvatanje org.jedinice za izmenu
     * @param sistemskaSifra (optional) 
     * @param verzija (optional) 
     */
    dajOJZaIzmenu(sistemskaSifra?: string | null | undefined, verzija?: string | null | undefined): Observable<DajOJResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajOJ?";
        if (sistemskaSifra !== undefined && sistemskaSifra !== null)
            url_ += "SistemskaSifra=" + encodeURIComponent("" + sistemskaSifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajOJZaIzmenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajOJZaIzmenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajOJResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajOJResponse>;
        }));
    }

    protected processDajOJZaIzmenu(response: HttpResponseBase): Observable<DajOJResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajOJResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajOJResponse>(null as any);
    }

    /**
     * Objava organizacione jedinice
     */
    objaviOJ(command: ObjaviOJCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/objaviOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObjaviOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processObjaviOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Objavljivanje organa
     */
    izmeniIObjaviOJ(command: ObjaviOJCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izmeniIObjaviOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzmeniIObjaviOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmeniIObjaviOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processIzmeniIObjaviOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Objavljivanje organa
     */
    kreirajNovuVerzijuIObjaviOJ(command: ObjaviOJCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/kreirajNovuVerzijuIObjaviOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processKreirajNovuVerzijuIObjaviOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajNovuVerzijuIObjaviOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processKreirajNovuVerzijuIObjaviOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Izvoz rezultata pretrage orgnaizacionih jedinica u excel
     * @param lang (optional) 
     * @param sifraOrgana (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param jBKJS (optional) 
     * @param sistemskaSifra (optional) 
     * @param nadleznaOrganizacionaJedinicaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param sifraDrzave (optional) 
     * @param sifraOpstine (optional) 
     * @param statusi (optional) 
     * @param pocetakVazenjaOd (optional) 
     * @param pocetakVazenjaDo (optional) 
     * @param krajVazenjaOd (optional) 
     * @param krajVazenjaDo (optional) 
     * @param imaVerzijuUPripremi (optional) 
     * @param imaVerzijuSaDatumomAktiviranjaUBuducnosti (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozOJUExcel(lang?: string | null | undefined, sifraOrgana?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, jBKJS?: string | null | undefined, sistemskaSifra?: string | null | undefined, nadleznaOrganizacionaJedinicaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, sifraDrzave?: string | null | undefined, sifraOpstine?: string | null | undefined, statusi?: string[] | null | undefined, pocetakVazenjaOd?: Date | null | undefined, pocetakVazenjaDo?: Date | null | undefined, krajVazenjaOd?: Date | null | undefined, krajVazenjaDo?: Date | null | undefined, imaVerzijuUPripremi?: boolean | undefined, imaVerzijuSaDatumomAktiviranjaUBuducnosti?: boolean | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izvozOJUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (sifraOrganizacioneJedinice !== undefined && sifraOrganizacioneJedinice !== null)
            url_ += "SifraOrganizacioneJedinice=" + encodeURIComponent("" + sifraOrganizacioneJedinice) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (sistemskaSifra !== undefined && sistemskaSifra !== null)
            url_ += "SistemskaSifra=" + encodeURIComponent("" + sistemskaSifra) + "&";
        if (nadleznaOrganizacionaJedinicaSifra !== undefined && nadleznaOrganizacionaJedinicaSifra !== null)
            url_ += "NadleznaOrganizacionaJedinicaSifra=" + encodeURIComponent("" + nadleznaOrganizacionaJedinicaSifra) + "&";
        if (vrstaOrganizacioneJediniceSifra !== undefined && vrstaOrganizacioneJediniceSifra !== null)
            url_ += "VrstaOrganizacioneJediniceSifra=" + encodeURIComponent("" + vrstaOrganizacioneJediniceSifra) + "&";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (skraceniNaziv !== undefined && skraceniNaziv !== null)
            url_ += "SkraceniNaziv=" + encodeURIComponent("" + skraceniNaziv) + "&";
        if (sifraDrzave !== undefined && sifraDrzave !== null)
            url_ += "SifraDrzave=" + encodeURIComponent("" + sifraDrzave) + "&";
        if (sifraOpstine !== undefined && sifraOpstine !== null)
            url_ += "SifraOpstine=" + encodeURIComponent("" + sifraOpstine) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (imaVerzijuUPripremi === null)
            throw new Error("The parameter 'imaVerzijuUPripremi' cannot be null.");
        else if (imaVerzijuUPripremi !== undefined)
            url_ += "ImaVerzijuUPripremi=" + encodeURIComponent("" + imaVerzijuUPripremi) + "&";
        if (imaVerzijuSaDatumomAktiviranjaUBuducnosti === null)
            throw new Error("The parameter 'imaVerzijuSaDatumomAktiviranjaUBuducnosti' cannot be null.");
        else if (imaVerzijuSaDatumomAktiviranjaUBuducnosti !== undefined)
            url_ += "ImaVerzijuSaDatumomAktiviranjaUBuducnosti=" + encodeURIComponent("" + imaVerzijuSaDatumomAktiviranjaUBuducnosti) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzvozOJUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozOJUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozOJUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Brisanje organizacione jedinice
     */
    obrisiOJ(command: ObrisiOJCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/obrisiOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObrisiOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processObrisiOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Deaktiviranje organizacione jedinice
     */
    deaktivirajOJ(command: DeaktivirajOJCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/deaktivirajOJ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeaktivirajOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processDeaktivirajOJ(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Prikaz svih verzija organizacione jedinice
     * @param sistemskaSifra (optional) 
     */
    dajSveVerzijeOJ(sistemskaSifra?: string | null | undefined): Observable<DajSveVerzijeOJResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveVerzijeOJ?";
        if (sistemskaSifra !== undefined && sistemskaSifra !== null)
            url_ += "SistemskaSifra=" + encodeURIComponent("" + sistemskaSifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveVerzijeOJ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveVerzijeOJ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveVerzijeOJResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveVerzijeOJResponse>;
        }));
    }

    protected processDajSveVerzijeOJ(response: HttpResponseBase): Observable<DajSveVerzijeOJResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DajSveVerzijeOJResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveVerzijeOJResponse>(null as any);
    }

    /**
     * Vracanje OJ iz statusa Ceka upis u katalog u Podaci u pripremi
     */
    povratakOJNaStatusUPripremi(command: PovratakOJNaStatusUPripremiCommand): Observable<GenericActionResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/povratakOJNaStatusUPripremi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPovratakOJNaStatusUPripremi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPovratakOJNaStatusUPripremi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponse>;
        }));
    }

    protected processPovratakOJNaStatusUPripremi(response: HttpResponseBase): Observable<GenericActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GenericActionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponse>(null as any);
    }

    /**
     * Dohvatanje svih organizacionih entiteta (objavljenih i aktivnih)
    Za kataloga postupaka
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param sistemskaSifra (optional) 
     * @param vrstaOrganaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param kategorija (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    dajSveAktivneObjavljeneEntitete(maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, sistemskaSifra?: string | null | undefined, vrstaOrganaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, kategorija?: string | null | undefined, nadlezniOrganSifra?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfDajSveAktivneObjavljeneEntitetResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/dajSveAktivneObjavljeneEntitete?";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (vrstaTeritorijalneNadleznostiSifra !== undefined && vrstaTeritorijalneNadleznostiSifra !== null)
            url_ += "VrstaTeritorijalneNadleznostiSifra=" + encodeURIComponent("" + vrstaTeritorijalneNadleznostiSifra) + "&";
        if (sifraOrganizacioneJedinice !== undefined && sifraOrganizacioneJedinice !== null)
            url_ += "SifraOrganizacioneJedinice=" + encodeURIComponent("" + sifraOrganizacioneJedinice) + "&";
        if (sistemskaSifra !== undefined && sistemskaSifra !== null)
            url_ += "SistemskaSifra=" + encodeURIComponent("" + sistemskaSifra) + "&";
        if (vrstaOrganaSifra !== undefined && vrstaOrganaSifra !== null)
            url_ += "VrstaOrganaSifra=" + encodeURIComponent("" + vrstaOrganaSifra) + "&";
        if (vrstaOrganizacioneJediniceSifra !== undefined && vrstaOrganizacioneJediniceSifra !== null)
            url_ += "VrstaOrganizacioneJediniceSifra=" + encodeURIComponent("" + vrstaOrganizacioneJediniceSifra) + "&";
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (skraceniNaziv !== undefined && skraceniNaziv !== null)
            url_ += "SkraceniNaziv=" + encodeURIComponent("" + skraceniNaziv) + "&";
        if (kategorija !== undefined && kategorija !== null)
            url_ += "Kategorija=" + encodeURIComponent("" + kategorija) + "&";
        if (nadlezniOrganSifra !== undefined && nadlezniOrganSifra !== null)
            url_ += "NadlezniOrganSifra=" + encodeURIComponent("" + nadlezniOrganSifra) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDajSveAktivneObjavljeneEntitete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveAktivneObjavljeneEntitete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfDajSveAktivneObjavljeneEntitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfDajSveAktivneObjavljeneEntitetResponse>;
        }));
    }

    protected processDajSveAktivneObjavljeneEntitete(response: HttpResponseBase): Observable<PagedResponseOfDajSveAktivneObjavljeneEntitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfDajSveAktivneObjavljeneEntitetResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfDajSveAktivneObjavljeneEntitetResponse>(null as any);
    }

    /**
     * Pretraga svih organizacionih entiteta po kriterijumima pretrage
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param sistemskaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param kategorija (optional) 
     * @param sifraNadleznogOrgana (optional) 
     * @param sifreIzabranihEntiteta (optional) 
     * @param statusi (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    objedinjenaPretragaEntiteta(maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, sistemskaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, kategorija?: string | null | undefined, sifraNadleznogOrgana?: string | null | undefined, sifreIzabranihEntiteta?: string[] | null | undefined, statusi?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfObjedinjenaPretragaEntitetaResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/objedinjenaPretragaEntiteta?";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (vrstaTeritorijalneNadleznostiSifra !== undefined && vrstaTeritorijalneNadleznostiSifra !== null)
            url_ += "VrstaTeritorijalneNadleznostiSifra=" + encodeURIComponent("" + vrstaTeritorijalneNadleznostiSifra) + "&";
        if (sifraOrganizacioneJedinice !== undefined && sifraOrganizacioneJedinice !== null)
            url_ += "SifraOrganizacioneJedinice=" + encodeURIComponent("" + sifraOrganizacioneJedinice) + "&";
        if (sistemskaSifra !== undefined && sistemskaSifra !== null)
            url_ += "SistemskaSifra=" + encodeURIComponent("" + sistemskaSifra) + "&";
        if (vrstaOrganizacioneJediniceSifra !== undefined && vrstaOrganizacioneJediniceSifra !== null)
            url_ += "VrstaOrganizacioneJediniceSifra=" + encodeURIComponent("" + vrstaOrganizacioneJediniceSifra) + "&";
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (skraceniNaziv !== undefined && skraceniNaziv !== null)
            url_ += "SkraceniNaziv=" + encodeURIComponent("" + skraceniNaziv) + "&";
        if (kategorija !== undefined && kategorija !== null)
            url_ += "Kategorija=" + encodeURIComponent("" + kategorija) + "&";
        if (sifraNadleznogOrgana !== undefined && sifraNadleznogOrgana !== null)
            url_ += "SifraNadleznogOrgana=" + encodeURIComponent("" + sifraNadleznogOrgana) + "&";
        if (sifreIzabranihEntiteta !== undefined && sifreIzabranihEntiteta !== null)
            sifreIzabranihEntiteta && sifreIzabranihEntiteta.forEach(item => { url_ += "SifreIzabranihEntiteta=" + encodeURIComponent("" + item) + "&"; });
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObjedinjenaPretragaEntiteta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjedinjenaPretragaEntiteta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaEntitetaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaEntitetaResponse>;
        }));
    }

    protected processObjedinjenaPretragaEntiteta(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaEntitetaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfObjedinjenaPretragaEntitetaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaEntitetaResponse>(null as any);
    }

    /**
     * Izvoz rezultata objedinjene pretrage orgnaizacionih entiteta u excel
     * @param lang (optional) 
     * @param maticniBroj (optional) 
     * @param pIB (optional) 
     * @param jBKJS (optional) 
     * @param vrstaTeritorijalneNadleznostiSifra (optional) 
     * @param sifraOrganizacioneJedinice (optional) 
     * @param sistemskaSifra (optional) 
     * @param vrstaOrganizacioneJediniceSifra (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param naziv (optional) 
     * @param skraceniNaziv (optional) 
     * @param kategorija (optional) 
     * @param sifraNadleznogOrgana (optional) 
     * @param sifreIzabranihEntiteta (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    izvozObjedinjenePretrageUExcel(lang?: string | null | undefined, maticniBroj?: string | null | undefined, pIB?: string | null | undefined, jBKJS?: string | null | undefined, vrstaTeritorijalneNadleznostiSifra?: string | null | undefined, sifraOrganizacioneJedinice?: string | null | undefined, sistemskaSifra?: string | null | undefined, vrstaOrganizacioneJediniceSifra?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, naziv?: string | null | undefined, skraceniNaziv?: string | null | undefined, kategorija?: string | null | undefined, sifraNadleznogOrgana?: string | null | undefined, sifreIzabranihEntiteta?: string[] | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/izvozObjedinjenePretrageUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (maticniBroj !== undefined && maticniBroj !== null)
            url_ += "MaticniBroj=" + encodeURIComponent("" + maticniBroj) + "&";
        if (pIB !== undefined && pIB !== null)
            url_ += "PIB=" + encodeURIComponent("" + pIB) + "&";
        if (jBKJS !== undefined && jBKJS !== null)
            url_ += "JBKJS=" + encodeURIComponent("" + jBKJS) + "&";
        if (vrstaTeritorijalneNadleznostiSifra !== undefined && vrstaTeritorijalneNadleznostiSifra !== null)
            url_ += "VrstaTeritorijalneNadleznostiSifra=" + encodeURIComponent("" + vrstaTeritorijalneNadleznostiSifra) + "&";
        if (sifraOrganizacioneJedinice !== undefined && sifraOrganizacioneJedinice !== null)
            url_ += "SifraOrganizacioneJedinice=" + encodeURIComponent("" + sifraOrganizacioneJedinice) + "&";
        if (sistemskaSifra !== undefined && sistemskaSifra !== null)
            url_ += "SistemskaSifra=" + encodeURIComponent("" + sistemskaSifra) + "&";
        if (vrstaOrganizacioneJediniceSifra !== undefined && vrstaOrganizacioneJediniceSifra !== null)
            url_ += "VrstaOrganizacioneJediniceSifra=" + encodeURIComponent("" + vrstaOrganizacioneJediniceSifra) + "&";
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (skraceniNaziv !== undefined && skraceniNaziv !== null)
            url_ += "SkraceniNaziv=" + encodeURIComponent("" + skraceniNaziv) + "&";
        if (kategorija !== undefined && kategorija !== null)
            url_ += "Kategorija=" + encodeURIComponent("" + kategorija) + "&";
        if (sifraNadleznogOrgana !== undefined && sifraNadleznogOrgana !== null)
            url_ += "SifraNadleznogOrgana=" + encodeURIComponent("" + sifraNadleznogOrgana) + "&";
        if (sifreIzabranihEntiteta !== undefined && sifreIzabranihEntiteta !== null)
            sifreIzabranihEntiteta && sifreIzabranihEntiteta.forEach(item => { url_ += "SifreIzabranihEntiteta=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIzvozObjedinjenePretrageUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozObjedinjenePretrageUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozObjedinjenePretrageUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Pretraga organizacionih entiteta po nazivu za popunjavanje autocomplete polja, kako ne bismo dovlacili sve
    Omogucena je pretraga organa, organizacionih jedinica i svih entiteta
     * @param naziv (optional) 
     * @param vrstaEntiteta (optional) 
     * @param statusi (optional) 
     * @param operacija (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     * @param operacijePoKompanijiFlag (optional) 
     */
    pretragaOrganizacionihEntitetaPoNazivu(naziv?: string | null | undefined, vrstaEntiteta?: number | undefined, statusi?: string[] | null | undefined, operacija?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined, operacijePoKompanijiFlag?: boolean | null | undefined): Observable<PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/pretragaOrganizacionihEntitetaPoNazivu?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (vrstaEntiteta === null)
            throw new Error("The parameter 'vrstaEntiteta' cannot be null.");
        else if (vrstaEntiteta !== undefined)
            url_ += "VrstaEntiteta=" + encodeURIComponent("" + vrstaEntiteta) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (operacija !== undefined && operacija !== null)
            url_ += "Operacija=" + encodeURIComponent("" + operacija) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (operacijePoKompanijiFlag !== undefined && operacijePoKompanijiFlag !== null)
            url_ += "operacijePoKompanijiFlag=" + encodeURIComponent("" + operacijePoKompanijiFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPretragaOrganizacionihEntitetaPoNazivu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaOrganizacionihEntitetaPoNazivu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse>;
        }));
    }

    protected processPretragaOrganizacionihEntitetaPoNazivu(response: HttpResponseBase): Observable<PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse>(null as any);
    }

    /**
     * Pretraga organizacionih entiteta na objedinjenoj pretrazi na nadleznosti, za katalog postupaka
    Omogucena je pretraga organa i organizacionih jedinica
     * @param naziv (optional) 
     * @param tipoviOrganaSifra (optional) 
     * @param vrstaEntiteta (optional) 
     * @param nadlezniOrganSifra (optional) 
     * @param keyword (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     */
    pretragaOENadleznosti(naziv?: string | null | undefined, tipoviOrganaSifra?: string[] | null | undefined, vrstaEntiteta?: number | undefined, nadlezniOrganSifra?: string | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined): Observable<PagedResponseOfOrganizacioniEntitetNadleznostiResponse> {
        let url_ = this.baseUrl + "/api/KatalogInstitucija/pretragaOENadleznosti?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (tipoviOrganaSifra !== undefined && tipoviOrganaSifra !== null)
            tipoviOrganaSifra && tipoviOrganaSifra.forEach(item => { url_ += "TipoviOrganaSifra=" + encodeURIComponent("" + item) + "&"; });
        if (vrstaEntiteta === null)
            throw new Error("The parameter 'vrstaEntiteta' cannot be null.");
        else if (vrstaEntiteta !== undefined)
            url_ += "VrstaEntiteta=" + encodeURIComponent("" + vrstaEntiteta) + "&";
        if (nadlezniOrganSifra !== undefined && nadlezniOrganSifra !== null)
            url_ += "NadlezniOrganSifra=" + encodeURIComponent("" + nadlezniOrganSifra) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPretragaOENadleznosti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaOENadleznosti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfOrganizacioniEntitetNadleznostiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfOrganizacioniEntitetNadleznostiResponse>;
        }));
    }

    protected processPretragaOENadleznosti(response: HttpResponseBase): Observable<PagedResponseOfOrganizacioniEntitetNadleznostiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResponseOfOrganizacioniEntitetNadleznostiResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfOrganizacioniEntitetNadleznostiResponse>(null as any);
    }
}

export interface IHealthCheckClient {
    getLiveness(): Observable<FileResponse | null>;
    getReadiness(): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class HealthCheckClient implements IHealthCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(KI_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9100";
    }

    getLiveness(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLiveness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiveness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetLiveness(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    getReadiness(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReadiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReadiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetReadiness(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class TestCreateOrUpdateCommand implements ITestCreateOrUpdateCommand {
    id?: number | undefined;
    name?: string | undefined;
    message?: string | undefined;

    constructor(data?: ITestCreateOrUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TestCreateOrUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TestCreateOrUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["message"] = this.message;
        return data;
    }
}

export interface ITestCreateOrUpdateCommand {
    id?: number | undefined;
    name?: string | undefined;
    message?: string | undefined;
}

export class DeleteTestCommand implements IDeleteTestCommand {
    id?: number | undefined;

    constructor(data?: IDeleteTestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteTestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteTestCommand {
    id?: number | undefined;
}

export class ExcelExportTestQuery implements IExcelExportTestQuery {

    constructor(data?: IExcelExportTestQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ExcelExportTestQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelExportTestQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IExcelExportTestQuery {
}

export class GenericActionResponse implements IGenericActionResponse {
    responseMessage?: string | undefined;
    responseBool!: boolean;
    warningMessage?: string | undefined;

    constructor(data?: IGenericActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
            this.responseBool = _data["responseBool"];
            this.warningMessage = _data["warningMessage"];
        }
    }

    static fromJS(data: any): GenericActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenericActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        data["responseBool"] = this.responseBool;
        data["warningMessage"] = this.warningMessage;
        return data;
    }
}

export interface IGenericActionResponse {
    responseMessage?: string | undefined;
    responseBool: boolean;
    warningMessage?: string | undefined;
}

export class GenericActionResponseWithItemsKIOfString extends GenericActionResponse implements IGenericActionResponseWithItemsKIOfString {
    items?: string | undefined;

    constructor(data?: IGenericActionResponseWithItemsKIOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.items = _data["items"];
        }
    }

    static fromJS(data: any): GenericActionResponseWithItemsKIOfString {
        data = typeof data === 'object' ? data : {};
        let result = new GenericActionResponseWithItemsKIOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericActionResponseWithItemsKIOfString extends IGenericActionResponse {
    items?: string | undefined;
}

export class SacuvajTeritorijalnuNadleznostCommand implements ISacuvajTeritorijalnuNadleznostCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;
    naziv?: string | undefined;
    sifraTipaTeritorijalneNadleznosti?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    zaOrgan!: boolean;
    sifraOrgana?: string | undefined;
    nadlezniOrgEntiteti?: NadlezniOrgEntitet[] | undefined;
    sifreNerasporedjenihTerNadleznosti?: string[] | undefined;

    constructor(data?: ISacuvajTeritorijalnuNadleznostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.verzija = _data["verzija"];
            this.naziv = _data["naziv"];
            this.sifraTipaTeritorijalneNadleznosti = _data["sifraTipaTeritorijalneNadleznosti"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.zaOrgan = _data["zaOrgan"];
            this.sifraOrgana = _data["sifraOrgana"];
            if (Array.isArray(_data["nadlezniOrgEntiteti"])) {
                this.nadlezniOrgEntiteti = [] as any;
                for (let item of _data["nadlezniOrgEntiteti"])
                    this.nadlezniOrgEntiteti!.push(NadlezniOrgEntitet.fromJS(item));
            }
            if (Array.isArray(_data["sifreNerasporedjenihTerNadleznosti"])) {
                this.sifreNerasporedjenihTerNadleznosti = [] as any;
                for (let item of _data["sifreNerasporedjenihTerNadleznosti"])
                    this.sifreNerasporedjenihTerNadleznosti!.push(item);
            }
        }
    }

    static fromJS(data: any): SacuvajTeritorijalnuNadleznostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajTeritorijalnuNadleznostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["verzija"] = this.verzija;
        data["naziv"] = this.naziv;
        data["sifraTipaTeritorijalneNadleznosti"] = this.sifraTipaTeritorijalneNadleznosti;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["zaOrgan"] = this.zaOrgan;
        data["sifraOrgana"] = this.sifraOrgana;
        if (Array.isArray(this.nadlezniOrgEntiteti)) {
            data["nadlezniOrgEntiteti"] = [];
            for (let item of this.nadlezniOrgEntiteti)
                data["nadlezniOrgEntiteti"].push(item.toJSON());
        }
        if (Array.isArray(this.sifreNerasporedjenihTerNadleznosti)) {
            data["sifreNerasporedjenihTerNadleznosti"] = [];
            for (let item of this.sifreNerasporedjenihTerNadleznosti)
                data["sifreNerasporedjenihTerNadleznosti"].push(item);
        }
        return data;
    }
}

export interface ISacuvajTeritorijalnuNadleznostCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;
    naziv?: string | undefined;
    sifraTipaTeritorijalneNadleznosti?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    zaOrgan: boolean;
    sifraOrgana?: string | undefined;
    nadlezniOrgEntiteti?: NadlezniOrgEntitet[] | undefined;
    sifreNerasporedjenihTerNadleznosti?: string[] | undefined;
}

export class NadlezniOrgEntitet implements INadlezniOrgEntitet {
    sifraEntiteta?: string | undefined;
    sifreStavkiTerNadleznosti?: string[] | undefined;

    constructor(data?: INadlezniOrgEntitet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraEntiteta = _data["sifraEntiteta"];
            if (Array.isArray(_data["sifreStavkiTerNadleznosti"])) {
                this.sifreStavkiTerNadleznosti = [] as any;
                for (let item of _data["sifreStavkiTerNadleznosti"])
                    this.sifreStavkiTerNadleznosti!.push(item);
            }
        }
    }

    static fromJS(data: any): NadlezniOrgEntitet {
        data = typeof data === 'object' ? data : {};
        let result = new NadlezniOrgEntitet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraEntiteta"] = this.sifraEntiteta;
        if (Array.isArray(this.sifreStavkiTerNadleznosti)) {
            data["sifreStavkiTerNadleznosti"] = [];
            for (let item of this.sifreStavkiTerNadleznosti)
                data["sifreStavkiTerNadleznosti"].push(item);
        }
        return data;
    }
}

export interface INadlezniOrgEntitet {
    sifraEntiteta?: string | undefined;
    sifreStavkiTerNadleznosti?: string[] | undefined;
}

export class ObjaviTeritorijalnuNadleznostCommand extends SacuvajTeritorijalnuNadleznostCommand implements IObjaviTeritorijalnuNadleznostCommand {

    constructor(data?: IObjaviTeritorijalnuNadleznostCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ObjaviTeritorijalnuNadleznostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviTeritorijalnuNadleznostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IObjaviTeritorijalnuNadleznostCommand extends ISacuvajTeritorijalnuNadleznostCommand {
}

export class PretragaStavkiTerNadleznostiResponse implements IPretragaStavkiTerNadleznostiResponse {
    items?: StavkaTeritorijalneNadleznostiResponse[] | undefined;

    constructor(data?: IPretragaStavkiTerNadleznostiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StavkaTeritorijalneNadleznostiResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PretragaStavkiTerNadleznostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaStavkiTerNadleznostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPretragaStavkiTerNadleznostiResponse {
    items?: StavkaTeritorijalneNadleznostiResponse[] | undefined;
}

export class StavkaTeritorijalneNadleznostiResponse implements IStavkaTeritorijalneNadleznostiResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    idIzSifarnika?: string | undefined;
    tipTeritorijalneNadleznostiSifra?: string | undefined;

    constructor(data?: IStavkaTeritorijalneNadleznostiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.idIzSifarnika = _data["idIzSifarnika"];
            this.tipTeritorijalneNadleznostiSifra = _data["tipTeritorijalneNadleznostiSifra"];
        }
    }

    static fromJS(data: any): StavkaTeritorijalneNadleznostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaTeritorijalneNadleznostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["idIzSifarnika"] = this.idIzSifarnika;
        data["tipTeritorijalneNadleznostiSifra"] = this.tipTeritorijalneNadleznostiSifra;
        return data;
    }
}

export interface IStavkaTeritorijalneNadleznostiResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    idIzSifarnika?: string | undefined;
    tipTeritorijalneNadleznostiSifra?: string | undefined;
}

export class TeritorijalnaNadleznostPodaciResponse implements ITeritorijalnaNadleznostPodaciResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    sifraTipaTeritorijalneNadleznosti?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    razlogDeaktiviranja?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    zaOrgan!: boolean;
    sifraOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    nadlezniOrgEntiteti?: NadlezniOrgEntitetResponse[] | undefined;
    nerasporedjeneStavkeTerNadleznosti?: StavkaTeritorijalneNadleznostiResponse[] | undefined;

    constructor(data?: ITeritorijalnaNadleznostPodaciResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.sifraTipaTeritorijalneNadleznosti = _data["sifraTipaTeritorijalneNadleznosti"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.razlogDeaktiviranja = _data["razlogDeaktiviranja"];
            this.statusSifra = _data["statusSifra"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.zaOrgan = _data["zaOrgan"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.nazivOrgana = _data["nazivOrgana"];
            if (Array.isArray(_data["nadlezniOrgEntiteti"])) {
                this.nadlezniOrgEntiteti = [] as any;
                for (let item of _data["nadlezniOrgEntiteti"])
                    this.nadlezniOrgEntiteti!.push(NadlezniOrgEntitetResponse.fromJS(item));
            }
            if (Array.isArray(_data["nerasporedjeneStavkeTerNadleznosti"])) {
                this.nerasporedjeneStavkeTerNadleznosti = [] as any;
                for (let item of _data["nerasporedjeneStavkeTerNadleznosti"])
                    this.nerasporedjeneStavkeTerNadleznosti!.push(StavkaTeritorijalneNadleznostiResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeritorijalnaNadleznostPodaciResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TeritorijalnaNadleznostPodaciResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["sifraTipaTeritorijalneNadleznosti"] = this.sifraTipaTeritorijalneNadleznosti;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["razlogDeaktiviranja"] = this.razlogDeaktiviranja;
        data["statusSifra"] = this.statusSifra;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["zaOrgan"] = this.zaOrgan;
        data["sifraOrgana"] = this.sifraOrgana;
        data["nazivOrgana"] = this.nazivOrgana;
        if (Array.isArray(this.nadlezniOrgEntiteti)) {
            data["nadlezniOrgEntiteti"] = [];
            for (let item of this.nadlezniOrgEntiteti)
                data["nadlezniOrgEntiteti"].push(item.toJSON());
        }
        if (Array.isArray(this.nerasporedjeneStavkeTerNadleznosti)) {
            data["nerasporedjeneStavkeTerNadleznosti"] = [];
            for (let item of this.nerasporedjeneStavkeTerNadleznosti)
                data["nerasporedjeneStavkeTerNadleznosti"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeritorijalnaNadleznostPodaciResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    sifraTipaTeritorijalneNadleznosti?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    razlogDeaktiviranja?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    zaOrgan: boolean;
    sifraOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    nadlezniOrgEntiteti?: NadlezniOrgEntitetResponse[] | undefined;
    nerasporedjeneStavkeTerNadleznosti?: StavkaTeritorijalneNadleznostiResponse[] | undefined;
}

export class NadlezniOrgEntitetResponse implements INadlezniOrgEntitetResponse {
    sifraEntiteta?: string | undefined;
    sifraOJ?: string | undefined;
    punNaziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
    vrstaNaziv?: string | undefined;
    opstinaNaziv?: string | undefined;
    sifreStavkiTerNadleznosti?: StavkaTeritorijalneNadleznostiResponse[] | undefined;
    nazivTN?: string | undefined;
    groupByKolona?: string | undefined;
    statusOE?: string | undefined;

    constructor(data?: INadlezniOrgEntitetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraEntiteta = _data["sifraEntiteta"];
            this.sifraOJ = _data["sifraOJ"];
            this.punNaziv = _data["punNaziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
            this.vrstaTeritorijalneNadleznostiNaziv = _data["vrstaTeritorijalneNadleznostiNaziv"];
            this.vrstaNaziv = _data["vrstaNaziv"];
            this.opstinaNaziv = _data["opstinaNaziv"];
            if (Array.isArray(_data["sifreStavkiTerNadleznosti"])) {
                this.sifreStavkiTerNadleznosti = [] as any;
                for (let item of _data["sifreStavkiTerNadleznosti"])
                    this.sifreStavkiTerNadleznosti!.push(StavkaTeritorijalneNadleznostiResponse.fromJS(item));
            }
            this.nazivTN = _data["nazivTN"];
            this.groupByKolona = _data["groupByKolona"];
            this.statusOE = _data["statusOE"];
        }
    }

    static fromJS(data: any): NadlezniOrgEntitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NadlezniOrgEntitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraEntiteta"] = this.sifraEntiteta;
        data["sifraOJ"] = this.sifraOJ;
        data["punNaziv"] = this.punNaziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        data["vrstaTeritorijalneNadleznostiNaziv"] = this.vrstaTeritorijalneNadleznostiNaziv;
        data["vrstaNaziv"] = this.vrstaNaziv;
        data["opstinaNaziv"] = this.opstinaNaziv;
        if (Array.isArray(this.sifreStavkiTerNadleznosti)) {
            data["sifreStavkiTerNadleznosti"] = [];
            for (let item of this.sifreStavkiTerNadleznosti)
                data["sifreStavkiTerNadleznosti"].push(item.toJSON());
        }
        data["nazivTN"] = this.nazivTN;
        data["groupByKolona"] = this.groupByKolona;
        data["statusOE"] = this.statusOE;
        return data;
    }
}

export interface INadlezniOrgEntitetResponse {
    sifraEntiteta?: string | undefined;
    sifraOJ?: string | undefined;
    punNaziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
    vrstaNaziv?: string | undefined;
    opstinaNaziv?: string | undefined;
    sifreStavkiTerNadleznosti?: StavkaTeritorijalneNadleznostiResponse[] | undefined;
    nazivTN?: string | undefined;
    groupByKolona?: string | undefined;
    statusOE?: string | undefined;
}

export class PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse implements IPagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse {
    items?: DajTeritorijalneNadleznostiPoKriterijumuPretrageResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DajTeritorijalneNadleznostiPoKriterijumuPretrageResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse {
    items?: DajTeritorijalneNadleznostiPoKriterijumuPretrageResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class DajTeritorijalneNadleznostiPoKriterijumuPretrageResponse implements IDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    naziv?: string | undefined;
    nadleznostZa?: string | undefined;
    tipTeritorijalneNadleznostiSifra?: string | undefined;
    tipTeritorijalneNadleznostiNaziv?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    nadlezniOrganizacioniEnitetNaziv?: string | undefined;
    teritorijalnaJedinicaNaziv?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.naziv = _data["naziv"];
            this.nadleznostZa = _data["nadleznostZa"];
            this.tipTeritorijalneNadleznostiSifra = _data["tipTeritorijalneNadleznostiSifra"];
            this.tipTeritorijalneNadleznostiNaziv = _data["tipTeritorijalneNadleznostiNaziv"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.nadlezniOrganizacioniEnitetNaziv = _data["nadlezniOrganizacioniEnitetNaziv"];
            this.teritorijalnaJedinicaNaziv = _data["teritorijalnaJedinicaNaziv"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): DajTeritorijalneNadleznostiPoKriterijumuPretrageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajTeritorijalneNadleznostiPoKriterijumuPretrageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["sifraOrgana"] = this.sifraOrgana;
        data["naziv"] = this.naziv;
        data["nadleznostZa"] = this.nadleznostZa;
        data["tipTeritorijalneNadleznostiSifra"] = this.tipTeritorijalneNadleznostiSifra;
        data["tipTeritorijalneNadleznostiNaziv"] = this.tipTeritorijalneNadleznostiNaziv;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["nadlezniOrganizacioniEnitetNaziv"] = this.nadlezniOrganizacioniEnitetNaziv;
        data["teritorijalnaJedinicaNaziv"] = this.teritorijalnaJedinicaNaziv;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IDajTeritorijalneNadleznostiPoKriterijumuPretrageResponse {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    naziv?: string | undefined;
    nadleznostZa?: string | undefined;
    tipTeritorijalneNadleznostiSifra?: string | undefined;
    tipTeritorijalneNadleznostiNaziv?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    nadlezniOrganizacioniEnitetNaziv?: string | undefined;
    teritorijalnaJedinicaNaziv?: string | undefined;
    verzija?: string | undefined;
}

export class DajVerzijeTeritorijalneNadleznostiResponse implements IDajVerzijeTeritorijalneNadleznostiResponse {
    verzije?: TerNadleznostVerzija[] | undefined;

    constructor(data?: IDajVerzijeTeritorijalneNadleznostiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["verzije"])) {
                this.verzije = [] as any;
                for (let item of _data["verzije"])
                    this.verzije!.push(TerNadleznostVerzija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajVerzijeTeritorijalneNadleznostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajVerzijeTeritorijalneNadleznostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.verzije)) {
            data["verzije"] = [];
            for (let item of this.verzije)
                data["verzije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajVerzijeTeritorijalneNadleznostiResponse {
    verzije?: TerNadleznostVerzija[] | undefined;
}

export class TerNadleznostVerzija implements ITerNadleznostVerzija {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    verzija?: string | undefined;
    naziv?: string | undefined;
    zaOrgan!: boolean;
    datumOd!: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    poslednjaVerzija!: boolean;
    sifraTipTeritorijalneNadleznosti?: string | undefined;
    nazivTipTeritorijalneNadleznosti?: string | undefined;
    korisnikKojiJeKreirao?: string | undefined;
    korisnikKojiJeMenjao?: string | undefined;

    constructor(data?: ITerNadleznostVerzija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.verzija = _data["verzija"];
            this.naziv = _data["naziv"];
            this.zaOrgan = _data["zaOrgan"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusNaziv = _data["statusNaziv"];
            this.statusSifra = _data["statusSifra"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.sifraTipTeritorijalneNadleznosti = _data["sifraTipTeritorijalneNadleznosti"];
            this.nazivTipTeritorijalneNadleznosti = _data["nazivTipTeritorijalneNadleznosti"];
            this.korisnikKojiJeKreirao = _data["korisnikKojiJeKreirao"];
            this.korisnikKojiJeMenjao = _data["korisnikKojiJeMenjao"];
        }
    }

    static fromJS(data: any): TerNadleznostVerzija {
        data = typeof data === 'object' ? data : {};
        let result = new TerNadleznostVerzija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["sifraOrgana"] = this.sifraOrgana;
        data["verzija"] = this.verzija;
        data["naziv"] = this.naziv;
        data["zaOrgan"] = this.zaOrgan;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusNaziv"] = this.statusNaziv;
        data["statusSifra"] = this.statusSifra;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["sifraTipTeritorijalneNadleznosti"] = this.sifraTipTeritorijalneNadleznosti;
        data["nazivTipTeritorijalneNadleznosti"] = this.nazivTipTeritorijalneNadleznosti;
        data["korisnikKojiJeKreirao"] = this.korisnikKojiJeKreirao;
        data["korisnikKojiJeMenjao"] = this.korisnikKojiJeMenjao;
        return data;
    }
}

export interface ITerNadleznostVerzija {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    verzija?: string | undefined;
    naziv?: string | undefined;
    zaOrgan: boolean;
    datumOd: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    poslednjaVerzija: boolean;
    sifraTipTeritorijalneNadleznosti?: string | undefined;
    nazivTipTeritorijalneNadleznosti?: string | undefined;
    korisnikKojiJeKreirao?: string | undefined;
    korisnikKojiJeMenjao?: string | undefined;
}

export class ObrisiTeritorijalnuNadleznostCommand implements IObrisiTeritorijalnuNadleznostCommand {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;

    constructor(data?: IObrisiTeritorijalnuNadleznostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.sifraOrgana = _data["sifraOrgana"];
        }
    }

    static fromJS(data: any): ObrisiTeritorijalnuNadleznostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiTeritorijalnuNadleznostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["sifraOrgana"] = this.sifraOrgana;
        return data;
    }
}

export interface IObrisiTeritorijalnuNadleznostCommand {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
}

export class DeaktivirajTeritorijalnuNadleznostCommand implements IDeaktivirajTeritorijalnuNadleznostCommand {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    datumDeaktivacije!: Date;
    razlog?: string | undefined;
    potvrdaBrisanjeVerzijeUPripremi!: boolean;

    constructor(data?: IDeaktivirajTeritorijalnuNadleznostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.datumDeaktivacije = _data["datumDeaktivacije"] ? new Date(_data["datumDeaktivacije"].toString()) : <any>undefined;
            this.razlog = _data["razlog"];
            this.potvrdaBrisanjeVerzijeUPripremi = _data["potvrdaBrisanjeVerzijeUPripremi"];
        }
    }

    static fromJS(data: any): DeaktivirajTeritorijalnuNadleznostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajTeritorijalnuNadleznostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["sifraOrgana"] = this.sifraOrgana;
        data["datumDeaktivacije"] = this.datumDeaktivacije ? this.datumDeaktivacije.toISOString() : <any>undefined;
        data["razlog"] = this.razlog;
        data["potvrdaBrisanjeVerzijeUPripremi"] = this.potvrdaBrisanjeVerzijeUPripremi;
        return data;
    }
}

export interface IDeaktivirajTeritorijalnuNadleznostCommand {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    datumDeaktivacije: Date;
    razlog?: string | undefined;
    potvrdaBrisanjeVerzijeUPripremi: boolean;
}

export class PovratakTeritorijalneNadleznostiNaStatusUPripremiCommand implements IPovratakTeritorijalneNadleznostiNaStatusUPripremiCommand {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IPovratakTeritorijalneNadleznostiNaStatusUPripremiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): PovratakTeritorijalneNadleznostiNaStatusUPripremiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PovratakTeritorijalneNadleznostiNaStatusUPripremiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["sifraOrgana"] = this.sifraOrgana;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IPovratakTeritorijalneNadleznostiNaStatusUPripremiCommand {
    sifra?: string | undefined;
    sifraOrgana?: string | undefined;
    verzija?: string | undefined;
}

export class DajSveInterneSifarnikeResponse implements IDajSveInterneSifarnikeResponse {
    statusOrgEntiteta?: StatusOrgEntitetaResponse[] | undefined;
    oblikSvojine?: OblikSvojineResponse[] | undefined;
    organTip?: OrganTipResponse[] | undefined;
    vrstaOrgana?: VrstaOrganaResponse[] | undefined;
    vrstaTeritorijalneNadleznosti?: VrstaTeritorijalneNadleznostiResponse[] | undefined;
    maticneEvidencije?: MaticneEvidencijeResponse[] | undefined;
    vrstaOrganizacioneJedinice?: VrstaOrganizacioneJediniceResponse[] | undefined;
    drzave?: DrzavaResponse[] | undefined;
    statusiVerzije?: StatusVerzijeResponse[] | undefined;
    tipoviTeritorijalneNadleznosti?: TipTeritorijalneNadleznosti[] | undefined;
    upravneJedinice?: UpravnaJedinicaResponse[] | undefined;

    constructor(data?: IDajSveInterneSifarnikeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statusOrgEntiteta"])) {
                this.statusOrgEntiteta = [] as any;
                for (let item of _data["statusOrgEntiteta"])
                    this.statusOrgEntiteta!.push(StatusOrgEntitetaResponse.fromJS(item));
            }
            if (Array.isArray(_data["oblikSvojine"])) {
                this.oblikSvojine = [] as any;
                for (let item of _data["oblikSvojine"])
                    this.oblikSvojine!.push(OblikSvojineResponse.fromJS(item));
            }
            if (Array.isArray(_data["organTip"])) {
                this.organTip = [] as any;
                for (let item of _data["organTip"])
                    this.organTip!.push(OrganTipResponse.fromJS(item));
            }
            if (Array.isArray(_data["vrstaOrgana"])) {
                this.vrstaOrgana = [] as any;
                for (let item of _data["vrstaOrgana"])
                    this.vrstaOrgana!.push(VrstaOrganaResponse.fromJS(item));
            }
            if (Array.isArray(_data["vrstaTeritorijalneNadleznosti"])) {
                this.vrstaTeritorijalneNadleznosti = [] as any;
                for (let item of _data["vrstaTeritorijalneNadleznosti"])
                    this.vrstaTeritorijalneNadleznosti!.push(VrstaTeritorijalneNadleznostiResponse.fromJS(item));
            }
            if (Array.isArray(_data["maticneEvidencije"])) {
                this.maticneEvidencije = [] as any;
                for (let item of _data["maticneEvidencije"])
                    this.maticneEvidencije!.push(MaticneEvidencijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["vrstaOrganizacioneJedinice"])) {
                this.vrstaOrganizacioneJedinice = [] as any;
                for (let item of _data["vrstaOrganizacioneJedinice"])
                    this.vrstaOrganizacioneJedinice!.push(VrstaOrganizacioneJediniceResponse.fromJS(item));
            }
            if (Array.isArray(_data["drzave"])) {
                this.drzave = [] as any;
                for (let item of _data["drzave"])
                    this.drzave!.push(DrzavaResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiVerzije"])) {
                this.statusiVerzije = [] as any;
                for (let item of _data["statusiVerzije"])
                    this.statusiVerzije!.push(StatusVerzijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["tipoviTeritorijalneNadleznosti"])) {
                this.tipoviTeritorijalneNadleznosti = [] as any;
                for (let item of _data["tipoviTeritorijalneNadleznosti"])
                    this.tipoviTeritorijalneNadleznosti!.push(TipTeritorijalneNadleznosti.fromJS(item));
            }
            if (Array.isArray(_data["upravneJedinice"])) {
                this.upravneJedinice = [] as any;
                for (let item of _data["upravneJedinice"])
                    this.upravneJedinice!.push(UpravnaJedinicaResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveInterneSifarnikeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveInterneSifarnikeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusOrgEntiteta)) {
            data["statusOrgEntiteta"] = [];
            for (let item of this.statusOrgEntiteta)
                data["statusOrgEntiteta"].push(item.toJSON());
        }
        if (Array.isArray(this.oblikSvojine)) {
            data["oblikSvojine"] = [];
            for (let item of this.oblikSvojine)
                data["oblikSvojine"].push(item.toJSON());
        }
        if (Array.isArray(this.organTip)) {
            data["organTip"] = [];
            for (let item of this.organTip)
                data["organTip"].push(item.toJSON());
        }
        if (Array.isArray(this.vrstaOrgana)) {
            data["vrstaOrgana"] = [];
            for (let item of this.vrstaOrgana)
                data["vrstaOrgana"].push(item.toJSON());
        }
        if (Array.isArray(this.vrstaTeritorijalneNadleznosti)) {
            data["vrstaTeritorijalneNadleznosti"] = [];
            for (let item of this.vrstaTeritorijalneNadleznosti)
                data["vrstaTeritorijalneNadleznosti"].push(item.toJSON());
        }
        if (Array.isArray(this.maticneEvidencije)) {
            data["maticneEvidencije"] = [];
            for (let item of this.maticneEvidencije)
                data["maticneEvidencije"].push(item.toJSON());
        }
        if (Array.isArray(this.vrstaOrganizacioneJedinice)) {
            data["vrstaOrganizacioneJedinice"] = [];
            for (let item of this.vrstaOrganizacioneJedinice)
                data["vrstaOrganizacioneJedinice"].push(item.toJSON());
        }
        if (Array.isArray(this.drzave)) {
            data["drzave"] = [];
            for (let item of this.drzave)
                data["drzave"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiVerzije)) {
            data["statusiVerzije"] = [];
            for (let item of this.statusiVerzije)
                data["statusiVerzije"].push(item.toJSON());
        }
        if (Array.isArray(this.tipoviTeritorijalneNadleznosti)) {
            data["tipoviTeritorijalneNadleznosti"] = [];
            for (let item of this.tipoviTeritorijalneNadleznosti)
                data["tipoviTeritorijalneNadleznosti"].push(item.toJSON());
        }
        if (Array.isArray(this.upravneJedinice)) {
            data["upravneJedinice"] = [];
            for (let item of this.upravneJedinice)
                data["upravneJedinice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveInterneSifarnikeResponse {
    statusOrgEntiteta?: StatusOrgEntitetaResponse[] | undefined;
    oblikSvojine?: OblikSvojineResponse[] | undefined;
    organTip?: OrganTipResponse[] | undefined;
    vrstaOrgana?: VrstaOrganaResponse[] | undefined;
    vrstaTeritorijalneNadleznosti?: VrstaTeritorijalneNadleznostiResponse[] | undefined;
    maticneEvidencije?: MaticneEvidencijeResponse[] | undefined;
    vrstaOrganizacioneJedinice?: VrstaOrganizacioneJediniceResponse[] | undefined;
    drzave?: DrzavaResponse[] | undefined;
    statusiVerzije?: StatusVerzijeResponse[] | undefined;
    tipoviTeritorijalneNadleznosti?: TipTeritorijalneNadleznosti[] | undefined;
    upravneJedinice?: UpravnaJedinicaResponse[] | undefined;
}

export class StatusOrgEntitetaResponse implements IStatusOrgEntitetaResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusOrgEntitetaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusOrgEntitetaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusOrgEntitetaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IStatusOrgEntitetaResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class OblikSvojineResponse implements IOblikSvojineResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
    nadredjeniOblikSvojineId?: number | undefined;

    constructor(data?: IOblikSvojineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
            this.nadredjeniOblikSvojineId = _data["nadredjeniOblikSvojineId"];
        }
    }

    static fromJS(data: any): OblikSvojineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OblikSvojineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        data["nadredjeniOblikSvojineId"] = this.nadredjeniOblikSvojineId;
        return data;
    }
}

export interface IOblikSvojineResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
    nadredjeniOblikSvojineId?: number | undefined;
}

export class OrganTipResponse implements IOrganTipResponse {
    id!: number;
    nazivTipa?: string | undefined;
    nazivTipaLatinica?: string | undefined;
    nadredjeniTipId?: number | undefined;
    sifra?: string | undefined;
    opis?: string | undefined;
    maticnaEvidencijaId!: number;
    obavezanUnosNadleznogOrgana?: boolean | undefined;

    constructor(data?: IOrganTipResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nazivTipa = _data["nazivTipa"];
            this.nazivTipaLatinica = _data["nazivTipaLatinica"];
            this.nadredjeniTipId = _data["nadredjeniTipId"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.maticnaEvidencijaId = _data["maticnaEvidencijaId"];
            this.obavezanUnosNadleznogOrgana = _data["obavezanUnosNadleznogOrgana"];
        }
    }

    static fromJS(data: any): OrganTipResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganTipResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nazivTipa"] = this.nazivTipa;
        data["nazivTipaLatinica"] = this.nazivTipaLatinica;
        data["nadredjeniTipId"] = this.nadredjeniTipId;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["maticnaEvidencijaId"] = this.maticnaEvidencijaId;
        data["obavezanUnosNadleznogOrgana"] = this.obavezanUnosNadleznogOrgana;
        return data;
    }
}

export interface IOrganTipResponse {
    id: number;
    nazivTipa?: string | undefined;
    nazivTipaLatinica?: string | undefined;
    nadredjeniTipId?: number | undefined;
    sifra?: string | undefined;
    opis?: string | undefined;
    maticnaEvidencijaId: number;
    obavezanUnosNadleznogOrgana?: boolean | undefined;
}

export class VrstaOrganaResponse implements IVrstaOrganaResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IVrstaOrganaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): VrstaOrganaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaOrganaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IVrstaOrganaResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class VrstaTeritorijalneNadleznostiResponse implements IVrstaTeritorijalneNadleznostiResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
    dozvoljenUnosZaOrgan?: boolean | undefined;
    nadredjenaVrstaTeritorijalneNadleznostiId?: number | undefined;
    nivo?: number | undefined;
    nazivUpravneJedinice?: string | undefined;

    constructor(data?: IVrstaTeritorijalneNadleznostiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
            this.dozvoljenUnosZaOrgan = _data["dozvoljenUnosZaOrgan"];
            this.nadredjenaVrstaTeritorijalneNadleznostiId = _data["nadredjenaVrstaTeritorijalneNadleznostiId"];
            this.nivo = _data["nivo"];
            this.nazivUpravneJedinice = _data["nazivUpravneJedinice"];
        }
    }

    static fromJS(data: any): VrstaTeritorijalneNadleznostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaTeritorijalneNadleznostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        data["dozvoljenUnosZaOrgan"] = this.dozvoljenUnosZaOrgan;
        data["nadredjenaVrstaTeritorijalneNadleznostiId"] = this.nadredjenaVrstaTeritorijalneNadleznostiId;
        data["nivo"] = this.nivo;
        data["nazivUpravneJedinice"] = this.nazivUpravneJedinice;
        return data;
    }
}

export interface IVrstaTeritorijalneNadleznostiResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
    dozvoljenUnosZaOrgan?: boolean | undefined;
    nadredjenaVrstaTeritorijalneNadleznostiId?: number | undefined;
    nivo?: number | undefined;
    nazivUpravneJedinice?: string | undefined;
}

export class MaticneEvidencijeResponse implements IMaticneEvidencijeResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IMaticneEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): MaticneEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaticneEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IMaticneEvidencijeResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class VrstaOrganizacioneJediniceResponse implements IVrstaOrganizacioneJediniceResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IVrstaOrganizacioneJediniceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): VrstaOrganizacioneJediniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaOrganizacioneJediniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IVrstaOrganizacioneJediniceResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class DrzavaResponse implements IDrzavaResponse {
    geoDataId!: number;
    countryAlphaCode2?: string | undefined;
    countryAlphaCode3?: string | undefined;
    cyrillicName?: string | undefined;
    latinName?: string | undefined;
    englishName?: string | undefined;

    constructor(data?: IDrzavaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geoDataId = _data["geoDataId"];
            this.countryAlphaCode2 = _data["countryAlphaCode2"];
            this.countryAlphaCode3 = _data["countryAlphaCode3"];
            this.cyrillicName = _data["cyrillicName"];
            this.latinName = _data["latinName"];
            this.englishName = _data["englishName"];
        }
    }

    static fromJS(data: any): DrzavaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DrzavaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geoDataId"] = this.geoDataId;
        data["countryAlphaCode2"] = this.countryAlphaCode2;
        data["countryAlphaCode3"] = this.countryAlphaCode3;
        data["cyrillicName"] = this.cyrillicName;
        data["latinName"] = this.latinName;
        data["englishName"] = this.englishName;
        return data;
    }
}

export interface IDrzavaResponse {
    geoDataId: number;
    countryAlphaCode2?: string | undefined;
    countryAlphaCode3?: string | undefined;
    cyrillicName?: string | undefined;
    latinName?: string | undefined;
    englishName?: string | undefined;
}

export class StatusVerzijeResponse implements IStatusVerzijeResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusVerzijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusVerzijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVerzijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IStatusVerzijeResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class TipTeritorijalneNadleznosti implements ITipTeritorijalneNadleznosti {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: ITipTeritorijalneNadleznosti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): TipTeritorijalneNadleznosti {
        data = typeof data === 'object' ? data : {};
        let result = new TipTeritorijalneNadleznosti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface ITipTeritorijalneNadleznosti {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
}

export class UpravnaJedinicaResponse implements IUpravnaJedinicaResponse {
    id!: number;
    naziv?: string | undefined;
    vrstaTeritorijalneNadleznostiId!: number;
    osnovni!: boolean;

    constructor(data?: IUpravnaJedinicaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.vrstaTeritorijalneNadleznostiId = _data["vrstaTeritorijalneNadleznostiId"];
            this.osnovni = _data["osnovni"];
        }
    }

    static fromJS(data: any): UpravnaJedinicaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpravnaJedinicaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["vrstaTeritorijalneNadleznostiId"] = this.vrstaTeritorijalneNadleznostiId;
        data["osnovni"] = this.osnovni;
        return data;
    }
}

export interface IUpravnaJedinicaResponse {
    id: number;
    naziv?: string | undefined;
    vrstaTeritorijalneNadleznostiId: number;
    osnovni: boolean;
}

export class DajSveInterneSifarnikeQuery implements IDajSveInterneSifarnikeQuery {

    constructor(data?: IDajSveInterneSifarnikeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DajSveInterneSifarnikeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveInterneSifarnikeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDajSveInterneSifarnikeQuery {
}

export class PagedResponseOfPromenaIzMaticnihEvidencijaResponse implements IPagedResponseOfPromenaIzMaticnihEvidencijaResponse {
    items?: PromenaIzMaticnihEvidencijaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPromenaIzMaticnihEvidencijaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PromenaIzMaticnihEvidencijaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPromenaIzMaticnihEvidencijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPromenaIzMaticnihEvidencijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPromenaIzMaticnihEvidencijaResponse {
    items?: PromenaIzMaticnihEvidencijaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PromenaIzMaticnihEvidencijaResponse implements IPromenaIzMaticnihEvidencijaResponse {
    id!: number;
    statusPromene?: string | undefined;
    vrstaPromene?: string | undefined;
    izvornaEvidencija?: string | undefined;
    relevantnostPromene?: string | undefined;
    mb?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    nazivOrgana?: string | undefined;
    datumPromene?: Date | undefined;

    constructor(data?: IPromenaIzMaticnihEvidencijaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusPromene = _data["statusPromene"];
            this.vrstaPromene = _data["vrstaPromene"];
            this.izvornaEvidencija = _data["izvornaEvidencija"];
            this.relevantnostPromene = _data["relevantnostPromene"];
            this.mb = _data["mb"];
            this.jbkjs = _data["jbkjs"];
            this.pib = _data["pib"];
            this.nazivOrgana = _data["nazivOrgana"];
            this.datumPromene = _data["datumPromene"] ? new Date(_data["datumPromene"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PromenaIzMaticnihEvidencijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PromenaIzMaticnihEvidencijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusPromene"] = this.statusPromene;
        data["vrstaPromene"] = this.vrstaPromene;
        data["izvornaEvidencija"] = this.izvornaEvidencija;
        data["relevantnostPromene"] = this.relevantnostPromene;
        data["mb"] = this.mb;
        data["jbkjs"] = this.jbkjs;
        data["pib"] = this.pib;
        data["nazivOrgana"] = this.nazivOrgana;
        data["datumPromene"] = this.datumPromene ? this.datumPromene.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPromenaIzMaticnihEvidencijaResponse {
    id: number;
    statusPromene?: string | undefined;
    vrstaPromene?: string | undefined;
    izvornaEvidencija?: string | undefined;
    relevantnostPromene?: string | undefined;
    mb?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    nazivOrgana?: string | undefined;
    datumPromene?: Date | undefined;
}

export class PreuzmiNovePromeneResponse implements IPreuzmiNovePromeneResponse {
    errors?: string[] | undefined;
    messages?: string[] | undefined;
    success!: boolean;
    processedCount!: number;
    failedCount!: number;

    constructor(data?: IPreuzmiNovePromeneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.success = _data["success"];
            this.processedCount = _data["processedCount"];
            this.failedCount = _data["failedCount"];
        }
    }

    static fromJS(data: any): PreuzmiNovePromeneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreuzmiNovePromeneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["success"] = this.success;
        data["processedCount"] = this.processedCount;
        data["failedCount"] = this.failedCount;
        return data;
    }
}

export interface IPreuzmiNovePromeneResponse {
    errors?: string[] | undefined;
    messages?: string[] | undefined;
    success: boolean;
    processedCount: number;
    failedCount: number;
}

export class PreuzmiNovePromeneIzMaticnihEvidencijaCommand implements IPreuzmiNovePromeneIzMaticnihEvidencijaCommand {
    promeneIzMaticnihEvidencijaSifreOrgana?: PromenaIzMaticneEvidencijePodaci[] | undefined;

    constructor(data?: IPreuzmiNovePromeneIzMaticnihEvidencijaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["promeneIzMaticnihEvidencijaSifreOrgana"])) {
                this.promeneIzMaticnihEvidencijaSifreOrgana = [] as any;
                for (let item of _data["promeneIzMaticnihEvidencijaSifreOrgana"])
                    this.promeneIzMaticnihEvidencijaSifreOrgana!.push(PromenaIzMaticneEvidencijePodaci.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreuzmiNovePromeneIzMaticnihEvidencijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PreuzmiNovePromeneIzMaticnihEvidencijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.promeneIzMaticnihEvidencijaSifreOrgana)) {
            data["promeneIzMaticnihEvidencijaSifreOrgana"] = [];
            for (let item of this.promeneIzMaticnihEvidencijaSifreOrgana)
                data["promeneIzMaticnihEvidencijaSifreOrgana"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPreuzmiNovePromeneIzMaticnihEvidencijaCommand {
    promeneIzMaticnihEvidencijaSifreOrgana?: PromenaIzMaticneEvidencijePodaci[] | undefined;
}

export class PromenaIzMaticneEvidencijePodaci implements IPromenaIzMaticneEvidencijePodaci {
    id!: number;
    izvornaEvidencija?: string | undefined;
    mb?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;

    constructor(data?: IPromenaIzMaticneEvidencijePodaci) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.izvornaEvidencija = _data["izvornaEvidencija"];
            this.mb = _data["mb"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
        }
    }

    static fromJS(data: any): PromenaIzMaticneEvidencijePodaci {
        data = typeof data === 'object' ? data : {};
        let result = new PromenaIzMaticneEvidencijePodaci();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["izvornaEvidencija"] = this.izvornaEvidencija;
        data["mb"] = this.mb;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        return data;
    }
}

export interface IPromenaIzMaticneEvidencijePodaci {
    id: number;
    izvornaEvidencija?: string | undefined;
    mb?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
}

export class OznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand implements IOznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand {
    id!: number;

    constructor(data?: IOznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IOznaciDaPromenaIzMaticneEvidencijeNijeRelevantnaCommand {
    id: number;
}

export class PromeniStatusPromeneUObradjenaCommand implements IPromeniStatusPromeneUObradjenaCommand {
    id!: number;

    constructor(data?: IPromeniStatusPromeneUObradjenaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PromeniStatusPromeneUObradjenaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PromeniStatusPromeneUObradjenaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPromeniStatusPromeneUObradjenaCommand {
    id: number;
}

export class OrganizacioniEntitet implements IOrganizacioniEntitet {
    mb!: string;
    pib!: string;
    jbkjs?: string | undefined;
    tipOrgana?: string | undefined;
    maticnaEvidencija?: string | undefined;
    maticnaEvidencijaId!: string;
    idIzMaticneEvidencije!: string;
    datumPreuzimanja?: string | undefined;
    nazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    nadlezniOrgan?: string | undefined;
    vrstaOrgana?: string | undefined;
    vrstaTerNadleznosti?: string | undefined;
    oblikSvojine?: string | undefined;
    status?: string | undefined;
    datumOsnivanja?: string | undefined;
    pravniOsnov?: string | undefined;
    adresaOrgana?: AdresaOrganizacionogEntiteta | undefined;
    kontaktPodaciOrgana?: KontaktPodaciOrganizacionogEntiteta | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;

    constructor(data?: IOrganizacioniEntitet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mb = _data["mb"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
            this.tipOrgana = _data["tipOrgana"];
            this.maticnaEvidencija = _data["maticnaEvidencija"];
            this.maticnaEvidencijaId = _data["maticnaEvidencijaId"];
            this.idIzMaticneEvidencije = _data["idIzMaticneEvidencije"];
            this.datumPreuzimanja = _data["datumPreuzimanja"];
            this.nazivOrgana = _data["nazivOrgana"];
            this.skraceniNazivOrgana = _data["skraceniNazivOrgana"];
            this.nadlezniOrgan = _data["nadlezniOrgan"];
            this.vrstaOrgana = _data["vrstaOrgana"];
            this.vrstaTerNadleznosti = _data["vrstaTerNadleznosti"];
            this.oblikSvojine = _data["oblikSvojine"];
            this.status = _data["status"];
            this.datumOsnivanja = _data["datumOsnivanja"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.adresaOrgana = _data["adresaOrgana"] ? AdresaOrganizacionogEntiteta.fromJS(_data["adresaOrgana"]) : <any>undefined;
            this.kontaktPodaciOrgana = _data["kontaktPodaciOrgana"] ? KontaktPodaciOrganizacionogEntiteta.fromJS(_data["kontaktPodaciOrgana"]) : <any>undefined;
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizacioniEntitet {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizacioniEntitet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mb"] = this.mb;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        data["tipOrgana"] = this.tipOrgana;
        data["maticnaEvidencija"] = this.maticnaEvidencija;
        data["maticnaEvidencijaId"] = this.maticnaEvidencijaId;
        data["idIzMaticneEvidencije"] = this.idIzMaticneEvidencije;
        data["datumPreuzimanja"] = this.datumPreuzimanja;
        data["nazivOrgana"] = this.nazivOrgana;
        data["skraceniNazivOrgana"] = this.skraceniNazivOrgana;
        data["nadlezniOrgan"] = this.nadlezniOrgan;
        data["vrstaOrgana"] = this.vrstaOrgana;
        data["vrstaTerNadleznosti"] = this.vrstaTerNadleznosti;
        data["oblikSvojine"] = this.oblikSvojine;
        data["status"] = this.status;
        data["datumOsnivanja"] = this.datumOsnivanja;
        data["pravniOsnov"] = this.pravniOsnov;
        data["adresaOrgana"] = this.adresaOrgana ? this.adresaOrgana.toJSON() : <any>undefined;
        data["kontaktPodaciOrgana"] = this.kontaktPodaciOrgana ? this.kontaktPodaciOrgana.toJSON() : <any>undefined;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrganizacioniEntitet {
    mb: string;
    pib: string;
    jbkjs?: string | undefined;
    tipOrgana?: string | undefined;
    maticnaEvidencija?: string | undefined;
    maticnaEvidencijaId: string;
    idIzMaticneEvidencije: string;
    datumPreuzimanja?: string | undefined;
    nazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    nadlezniOrgan?: string | undefined;
    vrstaOrgana?: string | undefined;
    vrstaTerNadleznosti?: string | undefined;
    oblikSvojine?: string | undefined;
    status?: string | undefined;
    datumOsnivanja?: string | undefined;
    pravniOsnov?: string | undefined;
    adresaOrgana?: AdresaOrganizacionogEntiteta | undefined;
    kontaktPodaciOrgana?: KontaktPodaciOrganizacionogEntiteta | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
}

export class AdresaOrganizacionogEntiteta implements IAdresaOrganizacionogEntiteta {
    adresa!: string;
    drzava!: string;
    opstinaSifra!: string;
    opstina!: string;
    mestoSifra!: string;
    mesto!: string;
    ulicaSifra!: string;
    ulicaVanSifarnika!: string;
    kucniBrojSifra!: string;
    kucniBrojVanSifarnika!: string;
    dodatak!: string;
    ulaz!: string;
    sprat!: string;
    stan!: string;

    constructor(data?: IAdresaOrganizacionogEntiteta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adresa = _data["adresa"];
            this.drzava = _data["drzava"];
            this.opstinaSifra = _data["opstinaSifra"];
            this.opstina = _data["opstina"];
            this.mestoSifra = _data["mestoSifra"];
            this.mesto = _data["mesto"];
            this.ulicaSifra = _data["ulicaSifra"];
            this.ulicaVanSifarnika = _data["ulicaVanSifarnika"];
            this.kucniBrojSifra = _data["kucniBrojSifra"];
            this.kucniBrojVanSifarnika = _data["kucniBrojVanSifarnika"];
            this.dodatak = _data["dodatak"];
            this.ulaz = _data["ulaz"];
            this.sprat = _data["sprat"];
            this.stan = _data["stan"];
        }
    }

    static fromJS(data: any): AdresaOrganizacionogEntiteta {
        data = typeof data === 'object' ? data : {};
        let result = new AdresaOrganizacionogEntiteta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adresa"] = this.adresa;
        data["drzava"] = this.drzava;
        data["opstinaSifra"] = this.opstinaSifra;
        data["opstina"] = this.opstina;
        data["mestoSifra"] = this.mestoSifra;
        data["mesto"] = this.mesto;
        data["ulicaSifra"] = this.ulicaSifra;
        data["ulicaVanSifarnika"] = this.ulicaVanSifarnika;
        data["kucniBrojSifra"] = this.kucniBrojSifra;
        data["kucniBrojVanSifarnika"] = this.kucniBrojVanSifarnika;
        data["dodatak"] = this.dodatak;
        data["ulaz"] = this.ulaz;
        data["sprat"] = this.sprat;
        data["stan"] = this.stan;
        return data;
    }
}

export interface IAdresaOrganizacionogEntiteta {
    adresa: string;
    drzava: string;
    opstinaSifra: string;
    opstina: string;
    mestoSifra: string;
    mesto: string;
    ulicaSifra: string;
    ulicaVanSifarnika: string;
    kucniBrojSifra: string;
    kucniBrojVanSifarnika: string;
    dodatak: string;
    ulaz: string;
    sprat: string;
    stan: string;
}

export class KontaktPodaciOrganizacionogEntiteta implements IKontaktPodaciOrganizacionogEntiteta {
    webAdresa!: string;
    emailAdresa!: string;
    telefon!: string;
    telefon2!: string;

    constructor(data?: IKontaktPodaciOrganizacionogEntiteta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webAdresa = _data["webAdresa"];
            this.emailAdresa = _data["emailAdresa"];
            this.telefon = _data["telefon"];
            this.telefon2 = _data["telefon2"];
        }
    }

    static fromJS(data: any): KontaktPodaciOrganizacionogEntiteta {
        data = typeof data === 'object' ? data : {};
        let result = new KontaktPodaciOrganizacionogEntiteta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webAdresa"] = this.webAdresa;
        data["emailAdresa"] = this.emailAdresa;
        data["telefon"] = this.telefon;
        data["telefon2"] = this.telefon2;
        return data;
    }
}

export interface IKontaktPodaciOrganizacionogEntiteta {
    webAdresa: string;
    emailAdresa: string;
    telefon: string;
    telefon2: string;
}

export class GetOrganPoEvidencijiCommand implements IGetOrganPoEvidencijiCommand {
    mb?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    maticnaEvidencijaId?: string | undefined;

    constructor(data?: IGetOrganPoEvidencijiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mb = _data["mb"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
            this.maticnaEvidencijaId = _data["maticnaEvidencijaId"];
        }
    }

    static fromJS(data: any): GetOrganPoEvidencijiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganPoEvidencijiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mb"] = this.mb;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        data["maticnaEvidencijaId"] = this.maticnaEvidencijaId;
        return data;
    }
}

export interface IGetOrganPoEvidencijiCommand {
    mb?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    maticnaEvidencijaId?: string | undefined;
}

export class GenericActionResponseWithItemsKIOfOrganizacioniEntitet extends GenericActionResponse implements IGenericActionResponseWithItemsKIOfOrganizacioniEntitet {
    items?: OrganizacioniEntitet2 | undefined;

    constructor(data?: IGenericActionResponseWithItemsKIOfOrganizacioniEntitet) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.items = _data["items"] ? OrganizacioniEntitet2.fromJS(_data["items"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GenericActionResponseWithItemsKIOfOrganizacioniEntitet {
        data = typeof data === 'object' ? data : {};
        let result = new GenericActionResponseWithItemsKIOfOrganizacioniEntitet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items ? this.items.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericActionResponseWithItemsKIOfOrganizacioniEntitet extends IGenericActionResponse {
    items?: OrganizacioniEntitet2 | undefined;
}

export class OrganizacioniEntitet2 implements IOrganizacioniEntitet2 {
    id?: number | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    idNadleznogOrgana?: number | undefined;
    sifraNadleznogOrgana?: string | undefined;
    nazivNadleznogOrgana?: string | undefined;
    organTipovi?: OrganTip[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    punNazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    sifraVrsteOrgana?: string | undefined;
    vrsteTeritorijalneNadleznosti?: string | undefined;
    upravnaJedinicaId?: number | undefined;
    sifraOblikSvojine?: string | undefined;
    adresa?: Adresa[] | undefined;
    kontaktPodaci?: Kontakt[] | undefined;
    datumOsnivanjaOrgana?: Date | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    pravniOsnov?: string | undefined;
    sifraMaticneEvidencije?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    razlogDeaktiviranja?: string | undefined;
    datumPreuzimanja?: Date | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    sifraOrgana?: string | undefined;
    statusVerzijeSifra?: string | undefined;

    constructor(data?: IOrganizacioniEntitet2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.maticniBroj = _data["maticniBroj"];
            this.jbkjs = _data["jbkjs"];
            this.pib = _data["pib"];
            this.idNadleznogOrgana = _data["idNadleznogOrgana"];
            this.sifraNadleznogOrgana = _data["sifraNadleznogOrgana"];
            this.nazivNadleznogOrgana = _data["nazivNadleznogOrgana"];
            if (Array.isArray(_data["organTipovi"])) {
                this.organTipovi = [] as any;
                for (let item of _data["organTipovi"])
                    this.organTipovi!.push(OrganTip.fromJS(item));
            }
            this.idIzMaticneEvidencije = _data["idIzMaticneEvidencije"];
            this.punNazivOrgana = _data["punNazivOrgana"];
            this.skraceniNazivOrgana = _data["skraceniNazivOrgana"];
            this.sifraVrsteOrgana = _data["sifraVrsteOrgana"];
            this.vrsteTeritorijalneNadleznosti = _data["vrsteTeritorijalneNadleznosti"];
            this.upravnaJedinicaId = _data["upravnaJedinicaId"];
            this.sifraOblikSvojine = _data["sifraOblikSvojine"];
            if (Array.isArray(_data["adresa"])) {
                this.adresa = [] as any;
                for (let item of _data["adresa"])
                    this.adresa!.push(Adresa.fromJS(item));
            }
            if (Array.isArray(_data["kontaktPodaci"])) {
                this.kontaktPodaci = [] as any;
                for (let item of _data["kontaktPodaci"])
                    this.kontaktPodaci!.push(Kontakt.fromJS(item));
            }
            this.datumOsnivanjaOrgana = _data["datumOsnivanjaOrgana"] ? new Date(_data["datumOsnivanjaOrgana"].toString()) : <any>undefined;
            this.statusIzMaticneEvidencije = _data["statusIzMaticneEvidencije"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.sifraMaticneEvidencije = _data["sifraMaticneEvidencije"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.razlogDeaktiviranja = _data["razlogDeaktiviranja"];
            this.datumPreuzimanja = _data["datumPreuzimanja"] ? new Date(_data["datumPreuzimanja"].toString()) : <any>undefined;
            this.statusSifra = _data["statusSifra"];
            this.verzija = _data["verzija"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
        }
    }

    static fromJS(data: any): OrganizacioniEntitet2 {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizacioniEntitet2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maticniBroj"] = this.maticniBroj;
        data["jbkjs"] = this.jbkjs;
        data["pib"] = this.pib;
        data["idNadleznogOrgana"] = this.idNadleznogOrgana;
        data["sifraNadleznogOrgana"] = this.sifraNadleznogOrgana;
        data["nazivNadleznogOrgana"] = this.nazivNadleznogOrgana;
        if (Array.isArray(this.organTipovi)) {
            data["organTipovi"] = [];
            for (let item of this.organTipovi)
                data["organTipovi"].push(item.toJSON());
        }
        data["idIzMaticneEvidencije"] = this.idIzMaticneEvidencije;
        data["punNazivOrgana"] = this.punNazivOrgana;
        data["skraceniNazivOrgana"] = this.skraceniNazivOrgana;
        data["sifraVrsteOrgana"] = this.sifraVrsteOrgana;
        data["vrsteTeritorijalneNadleznosti"] = this.vrsteTeritorijalneNadleznosti;
        data["upravnaJedinicaId"] = this.upravnaJedinicaId;
        data["sifraOblikSvojine"] = this.sifraOblikSvojine;
        if (Array.isArray(this.adresa)) {
            data["adresa"] = [];
            for (let item of this.adresa)
                data["adresa"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktPodaci)) {
            data["kontaktPodaci"] = [];
            for (let item of this.kontaktPodaci)
                data["kontaktPodaci"].push(item.toJSON());
        }
        data["datumOsnivanjaOrgana"] = this.datumOsnivanjaOrgana ? this.datumOsnivanjaOrgana.toISOString() : <any>undefined;
        data["statusIzMaticneEvidencije"] = this.statusIzMaticneEvidencije;
        data["pravniOsnov"] = this.pravniOsnov;
        data["sifraMaticneEvidencije"] = this.sifraMaticneEvidencije;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["razlogDeaktiviranja"] = this.razlogDeaktiviranja;
        data["datumPreuzimanja"] = this.datumPreuzimanja ? this.datumPreuzimanja.toISOString() : <any>undefined;
        data["statusSifra"] = this.statusSifra;
        data["verzija"] = this.verzija;
        data["sifraOrgana"] = this.sifraOrgana;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        return data;
    }
}

export interface IOrganizacioniEntitet2 {
    id?: number | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    idNadleznogOrgana?: number | undefined;
    sifraNadleznogOrgana?: string | undefined;
    nazivNadleznogOrgana?: string | undefined;
    organTipovi?: OrganTip[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    punNazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    sifraVrsteOrgana?: string | undefined;
    vrsteTeritorijalneNadleznosti?: string | undefined;
    upravnaJedinicaId?: number | undefined;
    sifraOblikSvojine?: string | undefined;
    adresa?: Adresa[] | undefined;
    kontaktPodaci?: Kontakt[] | undefined;
    datumOsnivanjaOrgana?: Date | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    pravniOsnov?: string | undefined;
    sifraMaticneEvidencije?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    razlogDeaktiviranja?: string | undefined;
    datumPreuzimanja?: Date | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    sifraOrgana?: string | undefined;
    statusVerzijeSifra?: string | undefined;
}

export class OrganTip implements IOrganTip {
    sifra?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IOrganTip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): OrganTip {
        data = typeof data === 'object' ? data : {};
        let result = new OrganTip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IOrganTip {
    sifra?: string | undefined;
    opis?: string | undefined;
}

export class Adresa implements IAdresa {
    id?: number | undefined;
    drzavaSifra?: string | undefined;
    opstinaSifra?: string | undefined;
    naseljenoMestoSifra?: string | undefined;
    ulicaSifra?: string | undefined;
    kucniBrojSifra?: string | undefined;
    ulicaVanSifarnika?: string | undefined;
    kucniBrojVanSifarnika?: string | undefined;
    dodatak?: string | undefined;
    ulaz?: string | undefined;
    sprat?: string | undefined;
    stan?: string | undefined;
    tekstualnaAdresa?: string | undefined;
    adresaIzMatEvidencije?: string | undefined;

    constructor(data?: IAdresa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drzavaSifra = _data["drzavaSifra"];
            this.opstinaSifra = _data["opstinaSifra"];
            this.naseljenoMestoSifra = _data["naseljenoMestoSifra"];
            this.ulicaSifra = _data["ulicaSifra"];
            this.kucniBrojSifra = _data["kucniBrojSifra"];
            this.ulicaVanSifarnika = _data["ulicaVanSifarnika"];
            this.kucniBrojVanSifarnika = _data["kucniBrojVanSifarnika"];
            this.dodatak = _data["dodatak"];
            this.ulaz = _data["ulaz"];
            this.sprat = _data["sprat"];
            this.stan = _data["stan"];
            this.tekstualnaAdresa = _data["tekstualnaAdresa"];
            this.adresaIzMatEvidencije = _data["adresaIzMatEvidencije"];
        }
    }

    static fromJS(data: any): Adresa {
        data = typeof data === 'object' ? data : {};
        let result = new Adresa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drzavaSifra"] = this.drzavaSifra;
        data["opstinaSifra"] = this.opstinaSifra;
        data["naseljenoMestoSifra"] = this.naseljenoMestoSifra;
        data["ulicaSifra"] = this.ulicaSifra;
        data["kucniBrojSifra"] = this.kucniBrojSifra;
        data["ulicaVanSifarnika"] = this.ulicaVanSifarnika;
        data["kucniBrojVanSifarnika"] = this.kucniBrojVanSifarnika;
        data["dodatak"] = this.dodatak;
        data["ulaz"] = this.ulaz;
        data["sprat"] = this.sprat;
        data["stan"] = this.stan;
        data["tekstualnaAdresa"] = this.tekstualnaAdresa;
        data["adresaIzMatEvidencije"] = this.adresaIzMatEvidencije;
        return data;
    }
}

export interface IAdresa {
    id?: number | undefined;
    drzavaSifra?: string | undefined;
    opstinaSifra?: string | undefined;
    naseljenoMestoSifra?: string | undefined;
    ulicaSifra?: string | undefined;
    kucniBrojSifra?: string | undefined;
    ulicaVanSifarnika?: string | undefined;
    kucniBrojVanSifarnika?: string | undefined;
    dodatak?: string | undefined;
    ulaz?: string | undefined;
    sprat?: string | undefined;
    stan?: string | undefined;
    tekstualnaAdresa?: string | undefined;
    adresaIzMatEvidencije?: string | undefined;
}

export class Kontakt implements IKontakt {
    id?: number | undefined;
    internetAdresa?: string | undefined;
    adresaEPoste?: string | undefined;
    telefon?: string | undefined;

    constructor(data?: IKontakt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.internetAdresa = _data["internetAdresa"];
            this.adresaEPoste = _data["adresaEPoste"];
            this.telefon = _data["telefon"];
        }
    }

    static fromJS(data: any): Kontakt {
        data = typeof data === 'object' ? data : {};
        let result = new Kontakt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["internetAdresa"] = this.internetAdresa;
        data["adresaEPoste"] = this.adresaEPoste;
        data["telefon"] = this.telefon;
        return data;
    }
}

export interface IKontakt {
    id?: number | undefined;
    internetAdresa?: string | undefined;
    adresaEPoste?: string | undefined;
    telefon?: string | undefined;
}

export class AtributSifraOrgana implements IAtributSifraOrgana {
    sifraOrgana?: string | undefined;

    constructor(data?: IAtributSifraOrgana) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraOrgana = _data["sifraOrgana"];
        }
    }

    static fromJS(data: any): AtributSifraOrgana {
        data = typeof data === 'object' ? data : {};
        let result = new AtributSifraOrgana();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraOrgana"] = this.sifraOrgana;
        return data;
    }
}

export interface IAtributSifraOrgana {
    sifraOrgana?: string | undefined;
}

export class SacuvajOrganizacioniEntitetCommand extends AtributSifraOrgana implements ISacuvajOrganizacioniEntitetCommand {
    id?: number | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    nadlezniOrganSifra?: string | undefined;
    nadlezniOrganId?: number | undefined;
    organTipovi?: OrganTip2[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    punNazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    sifraVrsteOrgana?: string | undefined;
    sifraOrgana?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    upravnaJedinicaId?: number | undefined;
    sifraOblikSvojine?: string | undefined;
    adresa?: Adresa2[] | undefined;
    kontaktPodaci?: Kontakt2[] | undefined;
    datumOsnivanjaOrgana?: Date | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    pravniOsnov?: string | undefined;
    sifraMaticneEvidencije?: string | undefined;
    datumOd?: Date | undefined;
    datumPreuzimanja?: Date | undefined;
    sifraStatusOrgana?: string | undefined;
    verzija?: string | undefined;
    akcijaCuvanja!: boolean;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;

    constructor(data?: ISacuvajOrganizacioniEntitetCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.maticniBroj = _data["maticniBroj"];
            this.jbkjs = _data["jbkjs"];
            this.pib = _data["pib"];
            this.nadlezniOrganSifra = _data["nadlezniOrganSifra"];
            this.nadlezniOrganId = _data["nadlezniOrganId"];
            if (Array.isArray(_data["organTipovi"])) {
                this.organTipovi = [] as any;
                for (let item of _data["organTipovi"])
                    this.organTipovi!.push(OrganTip2.fromJS(item));
            }
            this.idIzMaticneEvidencije = _data["idIzMaticneEvidencije"];
            this.punNazivOrgana = _data["punNazivOrgana"];
            this.skraceniNazivOrgana = _data["skraceniNazivOrgana"];
            this.sifraVrsteOrgana = _data["sifraVrsteOrgana"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.sifraVrsteTeritorijalneNadleznosti = _data["sifraVrsteTeritorijalneNadleznosti"];
            this.upravnaJedinicaId = _data["upravnaJedinicaId"];
            this.sifraOblikSvojine = _data["sifraOblikSvojine"];
            if (Array.isArray(_data["adresa"])) {
                this.adresa = [] as any;
                for (let item of _data["adresa"])
                    this.adresa!.push(Adresa2.fromJS(item));
            }
            if (Array.isArray(_data["kontaktPodaci"])) {
                this.kontaktPodaci = [] as any;
                for (let item of _data["kontaktPodaci"])
                    this.kontaktPodaci!.push(Kontakt2.fromJS(item));
            }
            this.datumOsnivanjaOrgana = _data["datumOsnivanjaOrgana"] ? new Date(_data["datumOsnivanjaOrgana"].toString()) : <any>undefined;
            this.statusIzMaticneEvidencije = _data["statusIzMaticneEvidencije"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.sifraMaticneEvidencije = _data["sifraMaticneEvidencije"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumPreuzimanja = _data["datumPreuzimanja"] ? new Date(_data["datumPreuzimanja"].toString()) : <any>undefined;
            this.sifraStatusOrgana = _data["sifraStatusOrgana"];
            this.verzija = _data["verzija"];
            this.akcijaCuvanja = _data["akcijaCuvanja"];
            this.syncSearchHash = _data["syncSearchHash"];
            this.dataHash = _data["dataHash"];
        }
    }

    static fromJS(data: any): SacuvajOrganizacioniEntitetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajOrganizacioniEntitetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maticniBroj"] = this.maticniBroj;
        data["jbkjs"] = this.jbkjs;
        data["pib"] = this.pib;
        data["nadlezniOrganSifra"] = this.nadlezniOrganSifra;
        data["nadlezniOrganId"] = this.nadlezniOrganId;
        if (Array.isArray(this.organTipovi)) {
            data["organTipovi"] = [];
            for (let item of this.organTipovi)
                data["organTipovi"].push(item.toJSON());
        }
        data["idIzMaticneEvidencije"] = this.idIzMaticneEvidencije;
        data["punNazivOrgana"] = this.punNazivOrgana;
        data["skraceniNazivOrgana"] = this.skraceniNazivOrgana;
        data["sifraVrsteOrgana"] = this.sifraVrsteOrgana;
        data["sifraOrgana"] = this.sifraOrgana;
        data["sifraVrsteTeritorijalneNadleznosti"] = this.sifraVrsteTeritorijalneNadleznosti;
        data["upravnaJedinicaId"] = this.upravnaJedinicaId;
        data["sifraOblikSvojine"] = this.sifraOblikSvojine;
        if (Array.isArray(this.adresa)) {
            data["adresa"] = [];
            for (let item of this.adresa)
                data["adresa"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktPodaci)) {
            data["kontaktPodaci"] = [];
            for (let item of this.kontaktPodaci)
                data["kontaktPodaci"].push(item.toJSON());
        }
        data["datumOsnivanjaOrgana"] = this.datumOsnivanjaOrgana ? this.datumOsnivanjaOrgana.toISOString() : <any>undefined;
        data["statusIzMaticneEvidencije"] = this.statusIzMaticneEvidencije;
        data["pravniOsnov"] = this.pravniOsnov;
        data["sifraMaticneEvidencije"] = this.sifraMaticneEvidencije;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumPreuzimanja"] = this.datumPreuzimanja ? this.datumPreuzimanja.toISOString() : <any>undefined;
        data["sifraStatusOrgana"] = this.sifraStatusOrgana;
        data["verzija"] = this.verzija;
        data["akcijaCuvanja"] = this.akcijaCuvanja;
        data["syncSearchHash"] = this.syncSearchHash;
        data["dataHash"] = this.dataHash;
        super.toJSON(data);
        return data;
    }
}

export interface ISacuvajOrganizacioniEntitetCommand extends IAtributSifraOrgana {
    id?: number | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    nadlezniOrganSifra?: string | undefined;
    nadlezniOrganId?: number | undefined;
    organTipovi?: OrganTip2[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    punNazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    sifraVrsteOrgana?: string | undefined;
    sifraOrgana?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    upravnaJedinicaId?: number | undefined;
    sifraOblikSvojine?: string | undefined;
    adresa?: Adresa2[] | undefined;
    kontaktPodaci?: Kontakt2[] | undefined;
    datumOsnivanjaOrgana?: Date | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    pravniOsnov?: string | undefined;
    sifraMaticneEvidencije?: string | undefined;
    datumOd?: Date | undefined;
    datumPreuzimanja?: Date | undefined;
    sifraStatusOrgana?: string | undefined;
    verzija?: string | undefined;
    akcijaCuvanja: boolean;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;
}

export class OrganTip2 implements IOrganTip2 {
    sifra?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IOrganTip2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): OrganTip2 {
        data = typeof data === 'object' ? data : {};
        let result = new OrganTip2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IOrganTip2 {
    sifra?: string | undefined;
    opis?: string | undefined;
}

export class Adresa2 implements IAdresa2 {
    id?: number | undefined;
    drzavaSifra?: string | undefined;
    opstinaSifra?: string | undefined;
    naseljenoMestoSifra?: string | undefined;
    ulicaSifra?: string | undefined;
    kucniBrojSifra?: string | undefined;
    ulicaVanSifarnika?: string | undefined;
    kucniBrojVanSifarnika?: string | undefined;
    dodatak?: string | undefined;
    ulaz?: string | undefined;
    sprat?: string | undefined;
    stan?: string | undefined;
    tekstualnaAdresa?: string | undefined;
    adresaIzMatEvidencije?: string | undefined;
    adresaSyncSearchHash?: string | undefined;
    adresaDataHash?: string | undefined;

    constructor(data?: IAdresa2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drzavaSifra = _data["drzavaSifra"];
            this.opstinaSifra = _data["opstinaSifra"];
            this.naseljenoMestoSifra = _data["naseljenoMestoSifra"];
            this.ulicaSifra = _data["ulicaSifra"];
            this.kucniBrojSifra = _data["kucniBrojSifra"];
            this.ulicaVanSifarnika = _data["ulicaVanSifarnika"];
            this.kucniBrojVanSifarnika = _data["kucniBrojVanSifarnika"];
            this.dodatak = _data["dodatak"];
            this.ulaz = _data["ulaz"];
            this.sprat = _data["sprat"];
            this.stan = _data["stan"];
            this.tekstualnaAdresa = _data["tekstualnaAdresa"];
            this.adresaIzMatEvidencije = _data["adresaIzMatEvidencije"];
            this.adresaSyncSearchHash = _data["adresaSyncSearchHash"];
            this.adresaDataHash = _data["adresaDataHash"];
        }
    }

    static fromJS(data: any): Adresa2 {
        data = typeof data === 'object' ? data : {};
        let result = new Adresa2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drzavaSifra"] = this.drzavaSifra;
        data["opstinaSifra"] = this.opstinaSifra;
        data["naseljenoMestoSifra"] = this.naseljenoMestoSifra;
        data["ulicaSifra"] = this.ulicaSifra;
        data["kucniBrojSifra"] = this.kucniBrojSifra;
        data["ulicaVanSifarnika"] = this.ulicaVanSifarnika;
        data["kucniBrojVanSifarnika"] = this.kucniBrojVanSifarnika;
        data["dodatak"] = this.dodatak;
        data["ulaz"] = this.ulaz;
        data["sprat"] = this.sprat;
        data["stan"] = this.stan;
        data["tekstualnaAdresa"] = this.tekstualnaAdresa;
        data["adresaIzMatEvidencije"] = this.adresaIzMatEvidencije;
        data["adresaSyncSearchHash"] = this.adresaSyncSearchHash;
        data["adresaDataHash"] = this.adresaDataHash;
        return data;
    }
}

export interface IAdresa2 {
    id?: number | undefined;
    drzavaSifra?: string | undefined;
    opstinaSifra?: string | undefined;
    naseljenoMestoSifra?: string | undefined;
    ulicaSifra?: string | undefined;
    kucniBrojSifra?: string | undefined;
    ulicaVanSifarnika?: string | undefined;
    kucniBrojVanSifarnika?: string | undefined;
    dodatak?: string | undefined;
    ulaz?: string | undefined;
    sprat?: string | undefined;
    stan?: string | undefined;
    tekstualnaAdresa?: string | undefined;
    adresaIzMatEvidencije?: string | undefined;
    adresaSyncSearchHash?: string | undefined;
    adresaDataHash?: string | undefined;
}

export class Kontakt2 implements IKontakt2 {
    id?: number | undefined;
    internetAdresa?: string | undefined;
    adresaEPoste?: string | undefined;
    telefon?: string | undefined;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;

    constructor(data?: IKontakt2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.internetAdresa = _data["internetAdresa"];
            this.adresaEPoste = _data["adresaEPoste"];
            this.telefon = _data["telefon"];
            this.syncSearchHash = _data["syncSearchHash"];
            this.dataHash = _data["dataHash"];
        }
    }

    static fromJS(data: any): Kontakt2 {
        data = typeof data === 'object' ? data : {};
        let result = new Kontakt2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["internetAdresa"] = this.internetAdresa;
        data["adresaEPoste"] = this.adresaEPoste;
        data["telefon"] = this.telefon;
        data["syncSearchHash"] = this.syncSearchHash;
        data["dataHash"] = this.dataHash;
        return data;
    }
}

export interface IKontakt2 {
    id?: number | undefined;
    internetAdresa?: string | undefined;
    adresaEPoste?: string | undefined;
    telefon?: string | undefined;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;
}

export class ObjaviOrganizacioniEntitetCommand extends AtributSifraOrgana implements IObjaviOrganizacioniEntitetCommand {
    id?: number | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    nadlezniOrganSifra?: string | undefined;
    nadlezniOrganId?: number | undefined;
    organTipovi?: OrganTip2[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    punNazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    sifraVrsteOrgana?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    upravnaJedinicaId?: number | undefined;
    sifraOblikSvojine?: string | undefined;
    adresa?: Adresa2[] | undefined;
    kontaktPodaci?: Kontakt2[] | undefined;
    datumOsnivanjaOrgana?: Date | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    pravniOsnov?: string | undefined;
    sifraMaticneEvidencije?: string | undefined;
    datumPreuzimanja?: Date | undefined;
    datumOd!: Date;
    sifraStatusOrgana?: string | undefined;
    verzija?: string | undefined;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;

    constructor(data?: IObjaviOrganizacioniEntitetCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.maticniBroj = _data["maticniBroj"];
            this.jbkjs = _data["jbkjs"];
            this.pib = _data["pib"];
            this.nadlezniOrganSifra = _data["nadlezniOrganSifra"];
            this.nadlezniOrganId = _data["nadlezniOrganId"];
            if (Array.isArray(_data["organTipovi"])) {
                this.organTipovi = [] as any;
                for (let item of _data["organTipovi"])
                    this.organTipovi!.push(OrganTip2.fromJS(item));
            }
            this.idIzMaticneEvidencije = _data["idIzMaticneEvidencije"];
            this.punNazivOrgana = _data["punNazivOrgana"];
            this.skraceniNazivOrgana = _data["skraceniNazivOrgana"];
            this.sifraVrsteOrgana = _data["sifraVrsteOrgana"];
            this.sifraVrsteTeritorijalneNadleznosti = _data["sifraVrsteTeritorijalneNadleznosti"];
            this.upravnaJedinicaId = _data["upravnaJedinicaId"];
            this.sifraOblikSvojine = _data["sifraOblikSvojine"];
            if (Array.isArray(_data["adresa"])) {
                this.adresa = [] as any;
                for (let item of _data["adresa"])
                    this.adresa!.push(Adresa2.fromJS(item));
            }
            if (Array.isArray(_data["kontaktPodaci"])) {
                this.kontaktPodaci = [] as any;
                for (let item of _data["kontaktPodaci"])
                    this.kontaktPodaci!.push(Kontakt2.fromJS(item));
            }
            this.datumOsnivanjaOrgana = _data["datumOsnivanjaOrgana"] ? new Date(_data["datumOsnivanjaOrgana"].toString()) : <any>undefined;
            this.statusIzMaticneEvidencije = _data["statusIzMaticneEvidencije"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.sifraMaticneEvidencije = _data["sifraMaticneEvidencije"];
            this.datumPreuzimanja = _data["datumPreuzimanja"] ? new Date(_data["datumPreuzimanja"].toString()) : <any>undefined;
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.sifraStatusOrgana = _data["sifraStatusOrgana"];
            this.verzija = _data["verzija"];
            this.syncSearchHash = _data["syncSearchHash"];
            this.dataHash = _data["dataHash"];
        }
    }

    static fromJS(data: any): ObjaviOrganizacioniEntitetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviOrganizacioniEntitetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maticniBroj"] = this.maticniBroj;
        data["jbkjs"] = this.jbkjs;
        data["pib"] = this.pib;
        data["nadlezniOrganSifra"] = this.nadlezniOrganSifra;
        data["nadlezniOrganId"] = this.nadlezniOrganId;
        if (Array.isArray(this.organTipovi)) {
            data["organTipovi"] = [];
            for (let item of this.organTipovi)
                data["organTipovi"].push(item.toJSON());
        }
        data["idIzMaticneEvidencije"] = this.idIzMaticneEvidencije;
        data["punNazivOrgana"] = this.punNazivOrgana;
        data["skraceniNazivOrgana"] = this.skraceniNazivOrgana;
        data["sifraVrsteOrgana"] = this.sifraVrsteOrgana;
        data["sifraVrsteTeritorijalneNadleznosti"] = this.sifraVrsteTeritorijalneNadleznosti;
        data["upravnaJedinicaId"] = this.upravnaJedinicaId;
        data["sifraOblikSvojine"] = this.sifraOblikSvojine;
        if (Array.isArray(this.adresa)) {
            data["adresa"] = [];
            for (let item of this.adresa)
                data["adresa"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktPodaci)) {
            data["kontaktPodaci"] = [];
            for (let item of this.kontaktPodaci)
                data["kontaktPodaci"].push(item.toJSON());
        }
        data["datumOsnivanjaOrgana"] = this.datumOsnivanjaOrgana ? this.datumOsnivanjaOrgana.toISOString() : <any>undefined;
        data["statusIzMaticneEvidencije"] = this.statusIzMaticneEvidencije;
        data["pravniOsnov"] = this.pravniOsnov;
        data["sifraMaticneEvidencije"] = this.sifraMaticneEvidencije;
        data["datumPreuzimanja"] = this.datumPreuzimanja ? this.datumPreuzimanja.toISOString() : <any>undefined;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["sifraStatusOrgana"] = this.sifraStatusOrgana;
        data["verzija"] = this.verzija;
        data["syncSearchHash"] = this.syncSearchHash;
        data["dataHash"] = this.dataHash;
        super.toJSON(data);
        return data;
    }
}

export interface IObjaviOrganizacioniEntitetCommand extends IAtributSifraOrgana {
    id?: number | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    nadlezniOrganSifra?: string | undefined;
    nadlezniOrganId?: number | undefined;
    organTipovi?: OrganTip2[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    punNazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
    sifraVrsteOrgana?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    upravnaJedinicaId?: number | undefined;
    sifraOblikSvojine?: string | undefined;
    adresa?: Adresa2[] | undefined;
    kontaktPodaci?: Kontakt2[] | undefined;
    datumOsnivanjaOrgana?: Date | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    pravniOsnov?: string | undefined;
    sifraMaticneEvidencije?: string | undefined;
    datumPreuzimanja?: Date | undefined;
    datumOd: Date;
    sifraStatusOrgana?: string | undefined;
    verzija?: string | undefined;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;
}

export class DajOrgEntitetResponse implements IDajOrgEntitetResponse {
    poruka?: string | undefined;
    organizacioniEntitet?: OrganizacioniEntitet2 | undefined;

    constructor(data?: IDajOrgEntitetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poruka = _data["poruka"];
            this.organizacioniEntitet = _data["organizacioniEntitet"] ? OrganizacioniEntitet2.fromJS(_data["organizacioniEntitet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DajOrgEntitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajOrgEntitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poruka"] = this.poruka;
        data["organizacioniEntitet"] = this.organizacioniEntitet ? this.organizacioniEntitet.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDajOrgEntitetResponse {
    poruka?: string | undefined;
    organizacioniEntitet?: OrganizacioniEntitet2 | undefined;
}

export class DeaktivirajOrganizacioniEntitetCommand extends AtributSifraOrgana implements IDeaktivirajOrganizacioniEntitetCommand {
    razlog?: string | undefined;
    datumDeaktivacije!: Date;
    potvrdaBrisanjeVerzijeUPripremi!: boolean;

    constructor(data?: IDeaktivirajOrganizacioniEntitetCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.razlog = _data["razlog"];
            this.datumDeaktivacije = _data["datumDeaktivacije"] ? new Date(_data["datumDeaktivacije"].toString()) : <any>undefined;
            this.potvrdaBrisanjeVerzijeUPripremi = _data["potvrdaBrisanjeVerzijeUPripremi"];
        }
    }

    static fromJS(data: any): DeaktivirajOrganizacioniEntitetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajOrganizacioniEntitetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["razlog"] = this.razlog;
        data["datumDeaktivacije"] = this.datumDeaktivacije ? this.datumDeaktivacije.toISOString() : <any>undefined;
        data["potvrdaBrisanjeVerzijeUPripremi"] = this.potvrdaBrisanjeVerzijeUPripremi;
        super.toJSON(data);
        return data;
    }
}

export interface IDeaktivirajOrganizacioniEntitetCommand extends IAtributSifraOrgana {
    razlog?: string | undefined;
    datumDeaktivacije: Date;
    potvrdaBrisanjeVerzijeUPripremi: boolean;
}

export class ObrisiOrganizacioniEntitetCommand extends AtributSifraOrgana implements IObrisiOrganizacioniEntitetCommand {

    constructor(data?: IObrisiOrganizacioniEntitetCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ObrisiOrganizacioniEntitetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiOrganizacioniEntitetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IObrisiOrganizacioniEntitetCommand extends IAtributSifraOrgana {
}

export class PagedResponseOfPretragaOrganizacionihEntitetaResponse implements IPagedResponseOfPretragaOrganizacionihEntitetaResponse {
    items?: PretragaOrganizacionihEntitetaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaOrganizacionihEntitetaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaOrganizacionihEntitetaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaOrganizacionihEntitetaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaOrganizacionihEntitetaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaOrganizacionihEntitetaResponse {
    items?: PretragaOrganizacionihEntitetaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaOrganizacionihEntitetaResponse implements IPretragaOrganizacionihEntitetaResponse {
    id?: string | undefined;
    sifraOrgana?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    nazivOrgana?: string | undefined;
    nazivNadleznogOrgana?: string | undefined;
    tipOrganaNaziv?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
    adresa?: string | undefined;
    opstina?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IPretragaOrganizacionihEntitetaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
            this.nazivOrgana = _data["nazivOrgana"];
            this.nazivNadleznogOrgana = _data["nazivNadleznogOrgana"];
            this.tipOrganaNaziv = _data["tipOrganaNaziv"];
            this.vrstaTeritorijalneNadleznostiNaziv = _data["vrstaTeritorijalneNadleznostiNaziv"];
            this.adresa = _data["adresa"];
            this.opstina = _data["opstina"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusNaziv = _data["statusNaziv"];
            this.statusSifra = _data["statusSifra"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): PretragaOrganizacionihEntitetaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaOrganizacionihEntitetaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraOrgana"] = this.sifraOrgana;
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        data["nazivOrgana"] = this.nazivOrgana;
        data["nazivNadleznogOrgana"] = this.nazivNadleznogOrgana;
        data["tipOrganaNaziv"] = this.tipOrganaNaziv;
        data["vrstaTeritorijalneNadleznostiNaziv"] = this.vrstaTeritorijalneNadleznostiNaziv;
        data["adresa"] = this.adresa;
        data["opstina"] = this.opstina;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusNaziv"] = this.statusNaziv;
        data["statusSifra"] = this.statusSifra;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IPretragaOrganizacionihEntitetaResponse {
    id?: string | undefined;
    sifraOrgana?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    nazivOrgana?: string | undefined;
    nazivNadleznogOrgana?: string | undefined;
    tipOrganaNaziv?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
    adresa?: string | undefined;
    opstina?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
}

export class PretragaPoIdentifikacionimPodacimaResponse implements IPretragaPoIdentifikacionimPodacimaResponse {
    responseMessages?: string[] | undefined;
    moguceJeNastavitiUnos!: boolean;
    items?: PretragaOrganizacionihEntitetaResponse[] | undefined;

    constructor(data?: IPretragaPoIdentifikacionimPodacimaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseMessages"])) {
                this.responseMessages = [] as any;
                for (let item of _data["responseMessages"])
                    this.responseMessages!.push(item);
            }
            this.moguceJeNastavitiUnos = _data["moguceJeNastavitiUnos"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaOrganizacionihEntitetaResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PretragaPoIdentifikacionimPodacimaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaPoIdentifikacionimPodacimaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseMessages)) {
            data["responseMessages"] = [];
            for (let item of this.responseMessages)
                data["responseMessages"].push(item);
        }
        data["moguceJeNastavitiUnos"] = this.moguceJeNastavitiUnos;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPretragaPoIdentifikacionimPodacimaResponse {
    responseMessages?: string[] | undefined;
    moguceJeNastavitiUnos: boolean;
    items?: PretragaOrganizacionihEntitetaResponse[] | undefined;
}

export class DajSveOrganeResponse implements IDajSveOrganeResponse {
    organ?: OrganResponse[] | undefined;

    constructor(data?: IDajSveOrganeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organ"])) {
                this.organ = [] as any;
                for (let item of _data["organ"])
                    this.organ!.push(OrganResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveOrganeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveOrganeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organ)) {
            data["organ"] = [];
            for (let item of this.organ)
                data["organ"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveOrganeResponse {
    organ?: OrganResponse[] | undefined;
}

export class OrganResponse implements IOrganResponse {
    id!: number;
    sifraOrgana?: string | undefined;
    punNazivOrgana?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;

    constructor(data?: IOrganResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.punNazivOrgana = _data["punNazivOrgana"];
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
        }
    }

    static fromJS(data: any): OrganResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraOrgana"] = this.sifraOrgana;
        data["punNazivOrgana"] = this.punNazivOrgana;
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        return data;
    }
}

export interface IOrganResponse {
    id: number;
    sifraOrgana?: string | undefined;
    punNazivOrgana?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
}

export class PagedResponseOfOrganResponse implements IPagedResponseOfOrganResponse {
    items?: OrganResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfOrganResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfOrganResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfOrganResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfOrganResponse {
    items?: OrganResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class DajSveObjavljeneOrganeQuery implements IDajSveObjavljeneOrganeQuery {

    constructor(data?: IDajSveObjavljeneOrganeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DajSveObjavljeneOrganeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveObjavljeneOrganeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDajSveObjavljeneOrganeQuery {
}

export class DajSveAktivneKorisnikoveOrgane implements IDajSveAktivneKorisnikoveOrgane {

    constructor(data?: IDajSveAktivneKorisnikoveOrgane) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DajSveAktivneKorisnikoveOrgane {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveAktivneKorisnikoveOrgane();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDajSveAktivneKorisnikoveOrgane {
}

export class DajOrganizacionuStrukturuOrganaResponse implements IDajOrganizacionuStrukturuOrganaResponse {
    organizacioneJedinice?: OrganizacionaJedinicaZaPrikazStrukture[] | undefined;

    constructor(data?: IDajOrganizacionuStrukturuOrganaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizacioneJedinice"])) {
                this.organizacioneJedinice = [] as any;
                for (let item of _data["organizacioneJedinice"])
                    this.organizacioneJedinice!.push(OrganizacionaJedinicaZaPrikazStrukture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajOrganizacionuStrukturuOrganaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajOrganizacionuStrukturuOrganaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizacioneJedinice)) {
            data["organizacioneJedinice"] = [];
            for (let item of this.organizacioneJedinice)
                data["organizacioneJedinice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajOrganizacionuStrukturuOrganaResponse {
    organizacioneJedinice?: OrganizacionaJedinicaZaPrikazStrukture[] | undefined;
}

export class OrganizacionaJedinicaZaPrikazStrukture implements IOrganizacionaJedinicaZaPrikazStrukture {
    sistemskaSifra?: string | undefined;
    nazivOJ?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    nadredjenaOJId?: number | undefined;
    idOj!: number;
    statusSifra?: string | undefined;

    constructor(data?: IOrganizacionaJedinicaZaPrikazStrukture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.nazivOJ = _data["nazivOJ"];
            this.sifraOrganizacioneJedinice = _data["sifraOrganizacioneJedinice"];
            this.nadredjenaOJId = _data["nadredjenaOJId"];
            this.idOj = _data["idOj"];
            this.statusSifra = _data["statusSifra"];
        }
    }

    static fromJS(data: any): OrganizacionaJedinicaZaPrikazStrukture {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizacionaJedinicaZaPrikazStrukture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["nazivOJ"] = this.nazivOJ;
        data["sifraOrganizacioneJedinice"] = this.sifraOrganizacioneJedinice;
        data["nadredjenaOJId"] = this.nadredjenaOJId;
        data["idOj"] = this.idOj;
        data["statusSifra"] = this.statusSifra;
        return data;
    }
}

export interface IOrganizacionaJedinicaZaPrikazStrukture {
    sistemskaSifra?: string | undefined;
    nazivOJ?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    nadredjenaOJId?: number | undefined;
    idOj: number;
    statusSifra?: string | undefined;
}

export class DajOrgEntiteteUSastavuResponse implements IDajOrgEntiteteUSastavuResponse {
    nazivOrgana?: string | undefined;
    naziviOrganaUSastavu?: string[] | undefined;
    naziviOrganaUNadleznosti?: string[] | undefined;

    constructor(data?: IDajOrgEntiteteUSastavuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivOrgana = _data["nazivOrgana"];
            if (Array.isArray(_data["naziviOrganaUSastavu"])) {
                this.naziviOrganaUSastavu = [] as any;
                for (let item of _data["naziviOrganaUSastavu"])
                    this.naziviOrganaUSastavu!.push(item);
            }
            if (Array.isArray(_data["naziviOrganaUNadleznosti"])) {
                this.naziviOrganaUNadleznosti = [] as any;
                for (let item of _data["naziviOrganaUNadleznosti"])
                    this.naziviOrganaUNadleznosti!.push(item);
            }
        }
    }

    static fromJS(data: any): DajOrgEntiteteUSastavuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajOrgEntiteteUSastavuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivOrgana"] = this.nazivOrgana;
        if (Array.isArray(this.naziviOrganaUSastavu)) {
            data["naziviOrganaUSastavu"] = [];
            for (let item of this.naziviOrganaUSastavu)
                data["naziviOrganaUSastavu"].push(item);
        }
        if (Array.isArray(this.naziviOrganaUNadleznosti)) {
            data["naziviOrganaUNadleznosti"] = [];
            for (let item of this.naziviOrganaUNadleznosti)
                data["naziviOrganaUNadleznosti"].push(item);
        }
        return data;
    }
}

export interface IDajOrgEntiteteUSastavuResponse {
    nazivOrgana?: string | undefined;
    naziviOrganaUSastavu?: string[] | undefined;
    naziviOrganaUNadleznosti?: string[] | undefined;
}

export class DajSveVerzijeOrganaResponse implements IDajSveVerzijeOrganaResponse {
    verzije?: OrganVerzija[] | undefined;

    constructor(data?: IDajSveVerzijeOrganaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["verzije"])) {
                this.verzije = [] as any;
                for (let item of _data["verzije"])
                    this.verzije!.push(OrganVerzija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveVerzijeOrganaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveVerzijeOrganaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.verzije)) {
            data["verzije"] = [];
            for (let item of this.verzije)
                data["verzije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveVerzijeOrganaResponse {
    verzije?: OrganVerzija[] | undefined;
}

export class OrganVerzija implements IOrganVerzija {
    sifraOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    korisnikKojiJeKreirao?: string | undefined;
    korisnikKojiJeMenjao?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;

    constructor(data?: IOrganVerzija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraOrgana = _data["sifraOrgana"];
            this.nazivOrgana = _data["nazivOrgana"];
            this.korisnikKojiJeKreirao = _data["korisnikKojiJeKreirao"];
            this.korisnikKojiJeMenjao = _data["korisnikKojiJeMenjao"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusNaziv = _data["statusNaziv"];
            this.statusSifra = _data["statusSifra"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
        }
    }

    static fromJS(data: any): OrganVerzija {
        data = typeof data === 'object' ? data : {};
        let result = new OrganVerzija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraOrgana"] = this.sifraOrgana;
        data["nazivOrgana"] = this.nazivOrgana;
        data["korisnikKojiJeKreirao"] = this.korisnikKojiJeKreirao;
        data["korisnikKojiJeMenjao"] = this.korisnikKojiJeMenjao;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusNaziv"] = this.statusNaziv;
        data["statusSifra"] = this.statusSifra;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        return data;
    }
}

export interface IOrganVerzija {
    sifraOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    korisnikKojiJeKreirao?: string | undefined;
    korisnikKojiJeMenjao?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
}

export class PovratakOrganaNaStatusUPripremiCommand implements IPovratakOrganaNaStatusUPripremiCommand {
    sifraOrgana?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IPovratakOrganaNaStatusUPripremiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraOrgana = _data["sifraOrgana"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): PovratakOrganaNaStatusUPripremiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PovratakOrganaNaStatusUPripremiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraOrgana"] = this.sifraOrgana;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IPovratakOrganaNaStatusUPripremiCommand {
    sifraOrgana?: string | undefined;
    verzija?: string | undefined;
}

export class PagedResponseOfPretragaOJResponse implements IPagedResponseOfPretragaOJResponse {
    items?: PretragaOJResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaOJResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaOJResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaOJResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaOJResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaOJResponse {
    items?: PretragaOJResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaOJResponse implements IPretragaOJResponse {
    id!: number;
    sifraOrgana?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    naziv?: string | undefined;
    nadredjenaOrganizacionaJedinicaNaziv?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
    vrstaNaziv?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    sistemskaSifra?: string | undefined;
    poslednjaVerzija!: boolean;

    constructor(data?: IPretragaOJResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.sifraOrganizacioneJedinice = _data["sifraOrganizacioneJedinice"];
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
            this.naziv = _data["naziv"];
            this.nadredjenaOrganizacionaJedinicaNaziv = _data["nadredjenaOrganizacionaJedinicaNaziv"];
            this.vrstaTeritorijalneNadleznostiNaziv = _data["vrstaTeritorijalneNadleznostiNaziv"];
            this.vrstaNaziv = _data["vrstaNaziv"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusNaziv = _data["statusNaziv"];
            this.statusSifra = _data["statusSifra"];
            this.verzija = _data["verzija"];
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
        }
    }

    static fromJS(data: any): PretragaOJResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaOJResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraOrgana"] = this.sifraOrgana;
        data["sifraOrganizacioneJedinice"] = this.sifraOrganizacioneJedinice;
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        data["naziv"] = this.naziv;
        data["nadredjenaOrganizacionaJedinicaNaziv"] = this.nadredjenaOrganizacionaJedinicaNaziv;
        data["vrstaTeritorijalneNadleznostiNaziv"] = this.vrstaTeritorijalneNadleznostiNaziv;
        data["vrstaNaziv"] = this.vrstaNaziv;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusNaziv"] = this.statusNaziv;
        data["statusSifra"] = this.statusSifra;
        data["verzija"] = this.verzija;
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        return data;
    }
}

export interface IPretragaOJResponse {
    id: number;
    sifraOrgana?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    naziv?: string | undefined;
    nadredjenaOrganizacionaJedinicaNaziv?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
    vrstaNaziv?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    sistemskaSifra?: string | undefined;
    poslednjaVerzija: boolean;
}

export class DajOJUSastavuOrganaResponse implements IDajOJUSastavuOrganaResponse {
    organizacioneJedinice?: OrganizacionaJedinica[] | undefined;

    constructor(data?: IDajOJUSastavuOrganaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizacioneJedinice"])) {
                this.organizacioneJedinice = [] as any;
                for (let item of _data["organizacioneJedinice"])
                    this.organizacioneJedinice!.push(OrganizacionaJedinica.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajOJUSastavuOrganaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajOJUSastavuOrganaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizacioneJedinice)) {
            data["organizacioneJedinice"] = [];
            for (let item of this.organizacioneJedinice)
                data["organizacioneJedinice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajOJUSastavuOrganaResponse {
    organizacioneJedinice?: OrganizacionaJedinica[] | undefined;
}

export class OrganizacionaJedinica implements IOrganizacionaJedinica {
    id!: number;
    sistemskaSifra?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: IOrganizacionaJedinica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.sifraOrganizacioneJedinice = _data["sifraOrganizacioneJedinice"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): OrganizacionaJedinica {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizacionaJedinica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["sifraOrganizacioneJedinice"] = this.sifraOrganizacioneJedinice;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IOrganizacionaJedinica {
    id: number;
    sistemskaSifra?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    naziv?: string | undefined;
}

export class AtributSistemskaSifra implements IAtributSistemskaSifra {
    sistemskaSifra?: string | undefined;

    constructor(data?: IAtributSistemskaSifra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sistemskaSifra = _data["sistemskaSifra"];
        }
    }

    static fromJS(data: any): AtributSistemskaSifra {
        data = typeof data === 'object' ? data : {};
        let result = new AtributSistemskaSifra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sistemskaSifra"] = this.sistemskaSifra;
        return data;
    }
}

export interface IAtributSistemskaSifra {
    sistemskaSifra?: string | undefined;
}

export class SacuvajOrganizacionuJedinicuCommand extends AtributSistemskaSifra implements ISacuvajOrganizacionuJedinicuCommand {
    id!: number;
    sistemskaSifra?: string | undefined;
    verzija?: string | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    datumOd?: Date | undefined;
    idIzMaticneEvidencije?: string | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    kontaktPodaci?: Kontakt2[] | undefined;
    adrese?: Adresa2[] | undefined;
    sifraOrgana?: string | undefined;
    organId!: number;
    nadredjenaOrganizacionaJedinicaSifra?: string | undefined;
    nadredjenaOrganizacionaJedinicaId?: number | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    vrstaOrganizacioneJediniceSifra?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    adresaOdOrgana!: boolean;
    imaMesnuNadleznost!: boolean;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;

    constructor(data?: ISacuvajOrganizacionuJedinicuCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.verzija = _data["verzija"];
            this.maticniBroj = _data["maticniBroj"];
            this.jbkjs = _data["jbkjs"];
            this.pib = _data["pib"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.idIzMaticneEvidencije = _data["idIzMaticneEvidencije"];
            this.statusIzMaticneEvidencije = _data["statusIzMaticneEvidencije"];
            if (Array.isArray(_data["kontaktPodaci"])) {
                this.kontaktPodaci = [] as any;
                for (let item of _data["kontaktPodaci"])
                    this.kontaktPodaci!.push(Kontakt2.fromJS(item));
            }
            if (Array.isArray(_data["adrese"])) {
                this.adrese = [] as any;
                for (let item of _data["adrese"])
                    this.adrese!.push(Adresa2.fromJS(item));
            }
            this.sifraOrgana = _data["sifraOrgana"];
            this.organId = _data["organId"];
            this.nadredjenaOrganizacionaJedinicaSifra = _data["nadredjenaOrganizacionaJedinicaSifra"];
            this.nadredjenaOrganizacionaJedinicaId = _data["nadredjenaOrganizacionaJedinicaId"];
            this.sifraOrganizacioneJedinice = _data["sifraOrganizacioneJedinice"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.vrstaOrganizacioneJediniceSifra = _data["vrstaOrganizacioneJediniceSifra"];
            this.sifraVrsteTeritorijalneNadleznosti = _data["sifraVrsteTeritorijalneNadleznosti"];
            this.adresaOdOrgana = _data["adresaOdOrgana"];
            this.imaMesnuNadleznost = _data["imaMesnuNadleznost"];
            this.syncSearchHash = _data["syncSearchHash"];
            this.dataHash = _data["dataHash"];
        }
    }

    static fromJS(data: any): SacuvajOrganizacionuJedinicuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajOrganizacionuJedinicuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["verzija"] = this.verzija;
        data["maticniBroj"] = this.maticniBroj;
        data["jbkjs"] = this.jbkjs;
        data["pib"] = this.pib;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["idIzMaticneEvidencije"] = this.idIzMaticneEvidencije;
        data["statusIzMaticneEvidencije"] = this.statusIzMaticneEvidencije;
        if (Array.isArray(this.kontaktPodaci)) {
            data["kontaktPodaci"] = [];
            for (let item of this.kontaktPodaci)
                data["kontaktPodaci"].push(item.toJSON());
        }
        if (Array.isArray(this.adrese)) {
            data["adrese"] = [];
            for (let item of this.adrese)
                data["adrese"].push(item.toJSON());
        }
        data["sifraOrgana"] = this.sifraOrgana;
        data["organId"] = this.organId;
        data["nadredjenaOrganizacionaJedinicaSifra"] = this.nadredjenaOrganizacionaJedinicaSifra;
        data["nadredjenaOrganizacionaJedinicaId"] = this.nadredjenaOrganizacionaJedinicaId;
        data["sifraOrganizacioneJedinice"] = this.sifraOrganizacioneJedinice;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["vrstaOrganizacioneJediniceSifra"] = this.vrstaOrganizacioneJediniceSifra;
        data["sifraVrsteTeritorijalneNadleznosti"] = this.sifraVrsteTeritorijalneNadleznosti;
        data["adresaOdOrgana"] = this.adresaOdOrgana;
        data["imaMesnuNadleznost"] = this.imaMesnuNadleznost;
        data["syncSearchHash"] = this.syncSearchHash;
        data["dataHash"] = this.dataHash;
        super.toJSON(data);
        return data;
    }
}

export interface ISacuvajOrganizacionuJedinicuCommand extends IAtributSistemskaSifra {
    id: number;
    sistemskaSifra?: string | undefined;
    verzija?: string | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    datumOd?: Date | undefined;
    idIzMaticneEvidencije?: string | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    kontaktPodaci?: Kontakt2[] | undefined;
    adrese?: Adresa2[] | undefined;
    sifraOrgana?: string | undefined;
    organId: number;
    nadredjenaOrganizacionaJedinicaSifra?: string | undefined;
    nadredjenaOrganizacionaJedinicaId?: number | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    vrstaOrganizacioneJediniceSifra?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    adresaOdOrgana: boolean;
    imaMesnuNadleznost: boolean;
    syncSearchHash?: string | undefined;
    dataHash?: string | undefined;
}

export class DajOJResponse implements IDajOJResponse {
    izmena!: boolean;
    organizacioniEntitet?: OrganizacioniEntitetOJ | undefined;

    constructor(data?: IDajOJResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.izmena = _data["izmena"];
            this.organizacioniEntitet = _data["organizacioniEntitet"] ? OrganizacioniEntitetOJ.fromJS(_data["organizacioniEntitet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DajOJResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajOJResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["izmena"] = this.izmena;
        data["organizacioniEntitet"] = this.organizacioniEntitet ? this.organizacioniEntitet.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDajOJResponse {
    izmena: boolean;
    organizacioniEntitet?: OrganizacioniEntitetOJ | undefined;
}

export class OrganizacioniEntitetOJ implements IOrganizacioniEntitetOJ {
    id?: number | undefined;
    sistemskaSifra?: string | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    sifraOrgana?: string | undefined;
    sistemskaSifraNadredjeneOrganizacioneJedinice?: string | undefined;
    sifraNadredjeneOrganizacioneJedinice?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    vrstaOrganizacioneJediniceSifra?: string | undefined;
    adresaOdOrgana!: boolean;
    adresa?: Adresa[] | undefined;
    kontaktPodaci?: Kontakt[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    razlogDeaktiviranja?: string | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    statusVerzijeSifra?: string | undefined;
    imaMesnuNadleznost!: boolean;

    constructor(data?: IOrganizacioniEntitetOJ) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.maticniBroj = _data["maticniBroj"];
            this.jbkjs = _data["jbkjs"];
            this.pib = _data["pib"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.sistemskaSifraNadredjeneOrganizacioneJedinice = _data["sistemskaSifraNadredjeneOrganizacioneJedinice"];
            this.sifraNadredjeneOrganizacioneJedinice = _data["sifraNadredjeneOrganizacioneJedinice"];
            this.sifraVrsteTeritorijalneNadleznosti = _data["sifraVrsteTeritorijalneNadleznosti"];
            this.sifraOrganizacioneJedinice = _data["sifraOrganizacioneJedinice"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.vrstaOrganizacioneJediniceSifra = _data["vrstaOrganizacioneJediniceSifra"];
            this.adresaOdOrgana = _data["adresaOdOrgana"];
            if (Array.isArray(_data["adresa"])) {
                this.adresa = [] as any;
                for (let item of _data["adresa"])
                    this.adresa!.push(Adresa.fromJS(item));
            }
            if (Array.isArray(_data["kontaktPodaci"])) {
                this.kontaktPodaci = [] as any;
                for (let item of _data["kontaktPodaci"])
                    this.kontaktPodaci!.push(Kontakt.fromJS(item));
            }
            this.idIzMaticneEvidencije = _data["idIzMaticneEvidencije"];
            this.statusIzMaticneEvidencije = _data["statusIzMaticneEvidencije"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.razlogDeaktiviranja = _data["razlogDeaktiviranja"];
            this.statusSifra = _data["statusSifra"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.imaMesnuNadleznost = _data["imaMesnuNadleznost"];
        }
    }

    static fromJS(data: any): OrganizacioniEntitetOJ {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizacioniEntitetOJ();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["maticniBroj"] = this.maticniBroj;
        data["jbkjs"] = this.jbkjs;
        data["pib"] = this.pib;
        data["sifraOrgana"] = this.sifraOrgana;
        data["sistemskaSifraNadredjeneOrganizacioneJedinice"] = this.sistemskaSifraNadredjeneOrganizacioneJedinice;
        data["sifraNadredjeneOrganizacioneJedinice"] = this.sifraNadredjeneOrganizacioneJedinice;
        data["sifraVrsteTeritorijalneNadleznosti"] = this.sifraVrsteTeritorijalneNadleznosti;
        data["sifraOrganizacioneJedinice"] = this.sifraOrganizacioneJedinice;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["vrstaOrganizacioneJediniceSifra"] = this.vrstaOrganizacioneJediniceSifra;
        data["adresaOdOrgana"] = this.adresaOdOrgana;
        if (Array.isArray(this.adresa)) {
            data["adresa"] = [];
            for (let item of this.adresa)
                data["adresa"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktPodaci)) {
            data["kontaktPodaci"] = [];
            for (let item of this.kontaktPodaci)
                data["kontaktPodaci"].push(item.toJSON());
        }
        data["idIzMaticneEvidencije"] = this.idIzMaticneEvidencije;
        data["statusIzMaticneEvidencije"] = this.statusIzMaticneEvidencije;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["razlogDeaktiviranja"] = this.razlogDeaktiviranja;
        data["statusSifra"] = this.statusSifra;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["imaMesnuNadleznost"] = this.imaMesnuNadleznost;
        return data;
    }
}

export interface IOrganizacioniEntitetOJ {
    id?: number | undefined;
    sistemskaSifra?: string | undefined;
    maticniBroj?: string | undefined;
    jbkjs?: string | undefined;
    pib?: string | undefined;
    sifraOrgana?: string | undefined;
    sistemskaSifraNadredjeneOrganizacioneJedinice?: string | undefined;
    sifraNadredjeneOrganizacioneJedinice?: string | undefined;
    sifraVrsteTeritorijalneNadleznosti?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    vrstaOrganizacioneJediniceSifra?: string | undefined;
    adresaOdOrgana: boolean;
    adresa?: Adresa[] | undefined;
    kontaktPodaci?: Kontakt[] | undefined;
    idIzMaticneEvidencije?: string | undefined;
    statusIzMaticneEvidencije?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    razlogDeaktiviranja?: string | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    statusVerzijeSifra?: string | undefined;
    imaMesnuNadleznost: boolean;
}

export class ObjaviOJCommand extends SacuvajOrganizacionuJedinicuCommand implements IObjaviOJCommand {

    constructor(data?: IObjaviOJCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ObjaviOJCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviOJCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IObjaviOJCommand extends ISacuvajOrganizacionuJedinicuCommand {
}

export class ObrisiOJCommand extends AtributSistemskaSifra implements IObrisiOJCommand {

    constructor(data?: IObrisiOJCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ObrisiOJCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiOJCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IObrisiOJCommand extends IAtributSistemskaSifra {
}

export class DeaktivirajOJCommand extends AtributSistemskaSifra implements IDeaktivirajOJCommand {
    datumDeaktivacije!: Date;
    razlog?: string | undefined;
    potvrdaBrisanjeVerzijeUPripremi!: boolean;

    constructor(data?: IDeaktivirajOJCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datumDeaktivacije = _data["datumDeaktivacije"] ? new Date(_data["datumDeaktivacije"].toString()) : <any>undefined;
            this.razlog = _data["razlog"];
            this.potvrdaBrisanjeVerzijeUPripremi = _data["potvrdaBrisanjeVerzijeUPripremi"];
        }
    }

    static fromJS(data: any): DeaktivirajOJCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajOJCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumDeaktivacije"] = this.datumDeaktivacije ? this.datumDeaktivacije.toISOString() : <any>undefined;
        data["razlog"] = this.razlog;
        data["potvrdaBrisanjeVerzijeUPripremi"] = this.potvrdaBrisanjeVerzijeUPripremi;
        super.toJSON(data);
        return data;
    }
}

export interface IDeaktivirajOJCommand extends IAtributSistemskaSifra {
    datumDeaktivacije: Date;
    razlog?: string | undefined;
    potvrdaBrisanjeVerzijeUPripremi: boolean;
}

export class DajSveVerzijeOJResponse implements IDajSveVerzijeOJResponse {
    verzije?: OJVerzija[] | undefined;

    constructor(data?: IDajSveVerzijeOJResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["verzije"])) {
                this.verzije = [] as any;
                for (let item of _data["verzije"])
                    this.verzije!.push(OJVerzija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveVerzijeOJResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveVerzijeOJResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.verzije)) {
            data["verzije"] = [];
            for (let item of this.verzije)
                data["verzije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveVerzijeOJResponse {
    verzije?: OJVerzija[] | undefined;
}

export class OJVerzija implements IOJVerzija {
    sifraOrgana?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    sistemskaSifra?: string | undefined;
    naziv?: string | undefined;
    nadredjenaOrganizacionaJedinicaNaziv?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    korisnikKojiJeKreirao?: string | undefined;
    korisnikKojiJeMenjao?: string | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;

    constructor(data?: IOJVerzija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraOrgana = _data["sifraOrgana"];
            this.sifraOrganizacioneJedinice = _data["sifraOrganizacioneJedinice"];
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.naziv = _data["naziv"];
            this.nadredjenaOrganizacionaJedinicaNaziv = _data["nadredjenaOrganizacionaJedinicaNaziv"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.korisnikKojiJeKreirao = _data["korisnikKojiJeKreirao"];
            this.korisnikKojiJeMenjao = _data["korisnikKojiJeMenjao"];
            this.statusNaziv = _data["statusNaziv"];
            this.statusSifra = _data["statusSifra"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
        }
    }

    static fromJS(data: any): OJVerzija {
        data = typeof data === 'object' ? data : {};
        let result = new OJVerzija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraOrgana"] = this.sifraOrgana;
        data["sifraOrganizacioneJedinice"] = this.sifraOrganizacioneJedinice;
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["naziv"] = this.naziv;
        data["nadredjenaOrganizacionaJedinicaNaziv"] = this.nadredjenaOrganizacionaJedinicaNaziv;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["korisnikKojiJeKreirao"] = this.korisnikKojiJeKreirao;
        data["korisnikKojiJeMenjao"] = this.korisnikKojiJeMenjao;
        data["statusNaziv"] = this.statusNaziv;
        data["statusSifra"] = this.statusSifra;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        return data;
    }
}

export interface IOJVerzija {
    sifraOrgana?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    sistemskaSifra?: string | undefined;
    naziv?: string | undefined;
    nadredjenaOrganizacionaJedinicaNaziv?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    korisnikKojiJeKreirao?: string | undefined;
    korisnikKojiJeMenjao?: string | undefined;
    statusNaziv?: string | undefined;
    statusSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
}

export class PovratakOJNaStatusUPripremiCommand implements IPovratakOJNaStatusUPripremiCommand {
    sistemskaSifra?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IPovratakOJNaStatusUPripremiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): PovratakOJNaStatusUPripremiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PovratakOJNaStatusUPripremiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IPovratakOJNaStatusUPripremiCommand {
    sistemskaSifra?: string | undefined;
    verzija?: string | undefined;
}

export class PagedResponseOfDajSveAktivneObjavljeneEntitetResponse implements IPagedResponseOfDajSveAktivneObjavljeneEntitetResponse {
    items?: DajSveAktivneObjavljeneEntitetResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfDajSveAktivneObjavljeneEntitetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DajSveAktivneObjavljeneEntitetResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfDajSveAktivneObjavljeneEntitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfDajSveAktivneObjavljeneEntitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfDajSveAktivneObjavljeneEntitetResponse {
    items?: DajSveAktivneObjavljeneEntitetResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class DajSveAktivneObjavljeneEntitetResponse implements IDajSveAktivneObjavljeneEntitetResponse {
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    nadredjeniOrganNaziv?: string | undefined;
    vrstaTeritorijalneNadleznosti?: string | undefined;
    tip?: string | undefined;
    sifraOrgana?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    sistemskaSifra?: string | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    opstina?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    sifraEntiteta?: string | undefined;
    izaberi?: boolean | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;

    constructor(data?: IDajSveAktivneObjavljeneEntitetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
            this.nadredjeniOrganNaziv = _data["nadredjeniOrganNaziv"];
            this.vrstaTeritorijalneNadleznosti = _data["vrstaTeritorijalneNadleznosti"];
            this.tip = _data["tip"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.sifraOrganizacioneJedinice = _data["sifraOrganizacioneJedinice"];
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
            this.opstina = _data["opstina"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.sifraEntiteta = _data["sifraEntiteta"];
            this.izaberi = _data["izaberi"];
            this.vrstaTeritorijalneNadleznostiNaziv = _data["vrstaTeritorijalneNadleznostiNaziv"];
        }
    }

    static fromJS(data: any): DajSveAktivneObjavljeneEntitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveAktivneObjavljeneEntitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        data["nadredjeniOrganNaziv"] = this.nadredjeniOrganNaziv;
        data["vrstaTeritorijalneNadleznosti"] = this.vrstaTeritorijalneNadleznosti;
        data["tip"] = this.tip;
        data["sifraOrgana"] = this.sifraOrgana;
        data["sifraOrganizacioneJedinice"] = this.sifraOrganizacioneJedinice;
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        data["opstina"] = this.opstina;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["sifraEntiteta"] = this.sifraEntiteta;
        data["izaberi"] = this.izaberi;
        data["vrstaTeritorijalneNadleznostiNaziv"] = this.vrstaTeritorijalneNadleznostiNaziv;
        return data;
    }
}

export interface IDajSveAktivneObjavljeneEntitetResponse {
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    nadredjeniOrganNaziv?: string | undefined;
    vrstaTeritorijalneNadleznosti?: string | undefined;
    tip?: string | undefined;
    sifraOrgana?: string | undefined;
    sifraOrganizacioneJedinice?: string | undefined;
    sistemskaSifra?: string | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    opstina?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    sifraEntiteta?: string | undefined;
    izaberi?: boolean | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
}

export class PagedResponseOfObjedinjenaPretragaEntitetaResponse implements IPagedResponseOfObjedinjenaPretragaEntitetaResponse {
    items?: ObjedinjenaPretragaEntitetaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfObjedinjenaPretragaEntitetaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObjedinjenaPretragaEntitetaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfObjedinjenaPretragaEntitetaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfObjedinjenaPretragaEntitetaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfObjedinjenaPretragaEntitetaResponse {
    items?: ObjedinjenaPretragaEntitetaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class ObjedinjenaPretragaEntitetaResponse implements IObjedinjenaPretragaEntitetaResponse {
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    nadredjeniOrganNaziv?: string | undefined;
    tip?: string | undefined;
    sifraOrgana?: string | undefined;
    sistemskaSifra?: string | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    opstina?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    sifra?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;

    constructor(data?: IObjedinjenaPretragaEntitetaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
            this.jbkjs = _data["jbkjs"];
            this.nadredjeniOrganNaziv = _data["nadredjeniOrganNaziv"];
            this.tip = _data["tip"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.sistemskaSifra = _data["sistemskaSifra"];
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
            this.opstina = _data["opstina"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.sifra = _data["sifra"];
            this.vrstaTeritorijalneNadleznostiNaziv = _data["vrstaTeritorijalneNadleznostiNaziv"];
        }
    }

    static fromJS(data: any): ObjedinjenaPretragaEntitetaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjedinjenaPretragaEntitetaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        data["jbkjs"] = this.jbkjs;
        data["nadredjeniOrganNaziv"] = this.nadredjeniOrganNaziv;
        data["tip"] = this.tip;
        data["sifraOrgana"] = this.sifraOrgana;
        data["sistemskaSifra"] = this.sistemskaSifra;
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        data["opstina"] = this.opstina;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["sifra"] = this.sifra;
        data["vrstaTeritorijalneNadleznostiNaziv"] = this.vrstaTeritorijalneNadleznostiNaziv;
        return data;
    }
}

export interface IObjedinjenaPretragaEntitetaResponse {
    maticniBroj?: string | undefined;
    pib?: string | undefined;
    jbkjs?: string | undefined;
    nadredjeniOrganNaziv?: string | undefined;
    tip?: string | undefined;
    sifraOrgana?: string | undefined;
    sistemskaSifra?: string | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    opstina?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    sifra?: string | undefined;
    vrstaTeritorijalneNadleznostiNaziv?: string | undefined;
}

export class PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse implements IPagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse {
    items?: PretragaOrganizacionihEntitetaPoNazivuResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaOrganizacionihEntitetaPoNazivuResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaOrganizacionihEntitetaPoNazivuResponse {
    items?: PretragaOrganizacionihEntitetaPoNazivuResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaOrganizacionihEntitetaPoNazivuResponse implements IPretragaOrganizacionihEntitetaPoNazivuResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;

    constructor(data?: IPretragaOrganizacionihEntitetaPoNazivuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
        }
    }

    static fromJS(data: any): PretragaOrganizacionihEntitetaPoNazivuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaOrganizacionihEntitetaPoNazivuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        return data;
    }
}

export interface IPretragaOrganizacionihEntitetaPoNazivuResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    maticniBroj?: string | undefined;
    pib?: string | undefined;
}

export class PagedResponseOfOrganizacioniEntitetNadleznostiResponse implements IPagedResponseOfOrganizacioniEntitetNadleznostiResponse {
    items?: OrganizacioniEntitetNadleznostiResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfOrganizacioniEntitetNadleznostiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizacioniEntitetNadleznostiResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfOrganizacioniEntitetNadleznostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfOrganizacioniEntitetNadleznostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfOrganizacioniEntitetNadleznostiResponse {
    items?: OrganizacioniEntitetNadleznostiResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class OrganizacioniEntitetNadleznostiResponse implements IOrganizacioniEntitetNadleznostiResponse {
    sifraEntiteta?: string | undefined;
    naziv?: string | undefined;
    jeOrgan?: boolean | undefined;
    izaberi?: boolean | undefined;
    sifraOrgana?: string | undefined;
    statusOE?: string | undefined;

    constructor(data?: IOrganizacioniEntitetNadleznostiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraEntiteta = _data["sifraEntiteta"];
            this.naziv = _data["naziv"];
            this.jeOrgan = _data["jeOrgan"];
            this.izaberi = _data["izaberi"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.statusOE = _data["statusOE"];
        }
    }

    static fromJS(data: any): OrganizacioniEntitetNadleznostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizacioniEntitetNadleznostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraEntiteta"] = this.sifraEntiteta;
        data["naziv"] = this.naziv;
        data["jeOrgan"] = this.jeOrgan;
        data["izaberi"] = this.izaberi;
        data["sifraOrgana"] = this.sifraOrgana;
        data["statusOE"] = this.statusOE;
        return data;
    }
}

export interface IOrganizacioniEntitetNadleznostiResponse {
    sifraEntiteta?: string | undefined;
    naziv?: string | undefined;
    jeOrgan?: boolean | undefined;
    izaberi?: boolean | undefined;
    sifraOrgana?: string | undefined;
    statusOE?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}